import React, { useState, useEffect, useRef, Fragment, useCallback } from 'react';
import { Popover, Transition } from '@headlessui/react'
//import { Fragment } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
// import { JSONTree } from 'react-json-tree';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/swiper-bundle.css';
// import { Pagination, Navigation } from 'swiper/modules';
// import 'swiper/css/pagination';
// import 'swiper/css/navigation';
// import BocceWorkflow from './BocceWorkflow';
// import BocceWorkflowNews from './BocceWorkflowNews';
import { usePDF } from 'react-to-pdf';
import { ImpulseSpinner, RotateSpinner } from "react-spinners-kit";
//import html2pdf from 'html2pdf.js';
import { motion, AnimatePresence } from "framer-motion";
//import { format } from 'date-fns';
import StoryLibrary from './StoryLibrary';
import PathPersonas from './PathPersonas';
import { discoveryTilesData } from '../data/discoveryTilesData'; // Added import

import { useNavigate, useLocation } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';
//import { useAuth } from '../contexts/AuthContext';
import KanbanBoard from './KanbanBoard';
import { XMarkIcon } from '@heroicons/react/20/solid'
//import Sticky from 'react-sticky-el';
import StickyBox from 'react-sticky-box';
import CompExplainer from './CompExplainer';
import SpeakIt from './CompAISpeakIt';
import CompAIStoryBoardItem from './CompAIStoryBoardItem';
import CardDeepQuestions from './CardDeepQuestions';
import GuidancePanel, { GuidanceBullet } from '../components/GuidancePanel';
import DiscoveryTile from './DiscoveryTile';
import PathProductDiscovery from './PathProductDiscovery';
import DeepSearch from './DeepSearch';
import StepWithShimmer from './StepWithShimmer'; // Add this import


//import { getFunctions, httpsCallable } from 'firebase/functions';
//import {app} from '../firebase-config';
//import { functions } from '../firebase-config';
//import { connectFunctionsEmulator } from 'firebase/functions';

//import app from "../firebase";

import { getFirestore, query, where, getDocs, orderBy, doc, deleteDoc, limit, addDoc, collection, serverTimestamp, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import app from "../firebase";
import {
    getFunctions,
    httpsCallable,
    connectFunctionsEmulator,
} from "firebase/functions";

import ReactConfetti from 'react-confetti';
import { useReactToPrint } from "react-to-print";
import { logCustomEvent } from './UtilAnalytics';
import CompPrintCover from './CompPrintCover';

import { ArcherContainer, ArcherElement } from 'react-archer';
import WebCrawlerModal from './CompAIBoard';
import CompAIStoryBoardCompanyBackground from './CompAIStoryBoardCompanyBackground'; // Added import
import CompAIStoryBoardLeadership from './CompAIStoryBoardLeadership'; // Import the new component

//import { useAuth } from '../contexts/AuthContext';
//import CompAIStoryTone from './CompAIStoryTone';
import Markdown from 'react-markdown'
import CompAIStoryBoardItemSource from './CompAIStoryBoardItemSource';
import CompAIStoryBoardIndustryItem from './CompAIStoryBoardIndustryItem'; // Added import
import CompAIStoryBoardItemSlide from './CompAIStoryBoardItemSlide'; // Import the new slide component
// import { Swiper, SwiperSlide } from 'swiper/react';
import ViewModeToggle, { getViewModePreference } from './ViewModeToggle';

import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';

import {
    Accordion,
    AccordionHeader,
    AccordionBody,
    Tabs,
    TabsHeader,
    TabsBody,
    Tab,
    TabPanel,
} from "@material-tailwind/react";
import CompAIStoryTone from './CompAIStoryTone';
import { executeGenerateStory } from '../services/storyService'; // IMPORT THE NEW SERVICE

import CompSourceUrlList from './CompSourceUrlList';

// Define the SVG for three dots
const ThreeDotsSVG = () => (
    <svg width="28" height="24" viewBox="0 0 34 34" fill="none" className="print:hidden" xmlns="http://www.w3.org/2000/svg">
        <circle cx="4" cy="16" r="4" fill="#333" />
        <circle cx="18" cy="16" r="4" fill="#333" />
        <circle cx="32" cy="16" r="4" fill="#333" />
    </svg>
);




const ThreeDotsSVGLoading = () => {
    // Animation variants for the circles

    const initialScale = 1;
    const finalScale = 1.25;

    const circleVariants = {
        initial: {
            scale: initialScale,
            fill: "#0C4A6E"
        },
        animate: (i) => ({
            scale: [initialScale, finalScale, initialScale],
            fill: ["#333", "#7DD3FC", "#333"],
            transition: {
                duration: 0.6,
                ease: "easeInOut",
                times: [0, 0.5, 1],
                repeat: Infinity,
                repeatDelay: 1.1, // Wait for all circles to finish (3 * 0.6)
                delay: i * 0.6 // Stagger based on circle index
            }
        })
    };

    return (
        <motion.svg
            width="28"
            height="24"
            viewBox="0 0 34 34"
        >
            <motion.circle
                cx="4"
                cy="16"
                r="4"
                initial="initial"
                animate="animate"
                variants={circleVariants}
                custom={0} // First circle
            />
            <motion.circle
                cx="18"
                cy="16"
                r="4"
                initial="initial"
                animate="animate"
                variants={circleVariants}
                custom={1} // Second circle
            />
            <motion.circle
                cx="32"
                cy="16"
                r="4"
                initial="initial"
                animate="animate"
                variants={circleVariants}
                custom={2} // Third circle
            />
        </motion.svg>
    );
};

const FiveDotsSVG = () => (
    <svg width="60" height="24" viewBox="0 0 74 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="4" cy="16" r="4" fill="#333" />
        <circle cx="18" cy="16" r="4" fill="#333" />
        <circle cx="32" cy="16" r="4" fill="#333" />
        <circle cx="46" cy="16" r="4" fill="#333" />
        <circle cx="60" cy="16" r="4" fill="#333" />
    </svg>
);

const FiveDotsSVGLoading = () => {
    // Animation variants for the circles remain the same
    const initialScale = 1;
    const finalScale = 1.25;

    const circleVariants = {
        initial: {
            scale: initialScale,
            fill: "#0C4A6E"
        },
        animate: (i) => ({
            scale: [initialScale, finalScale, initialScale],
            fill: ["#333", "#7DD3FC", "#333"],
            transition: {
                duration: 0.6,
                ease: "easeInOut",
                times: [0, 0.5, 1],
                repeat: Infinity,
                repeatDelay: 1.9,
                delay: i * 0.3
            }
        })
    };

    return (
        <motion.svg
            width="60"
            height="24"
            viewBox="0 0 74 34"
        >
            <motion.circle
                cx="4"
                cy="16"
                r="4"
                initial="initial"
                animate="animate"
                variants={circleVariants}
                custom={0}
            />
            <motion.circle
                cx="18"
                cy="16"
                r="4"
                initial="initial"
                animate="animate"
                variants={circleVariants}
                custom={1}
            />
            <motion.circle
                cx="32"
                cy="16"
                r="4"
                initial="initial"
                animate="animate"
                variants={circleVariants}
                custom={2}
            />
            <motion.circle
                cx="46"
                cy="16"
                r="4"
                initial="initial"
                animate="animate"
                variants={circleVariants}
                custom={3}
            />
            <motion.circle
                cx="60"
                cy="16"
                r="4"
                initial="initial"
                animate="animate"
                variants={circleVariants}
                custom={4}
            />
        </motion.svg>
    );
};

const Icon = ({ id, open, isLoading = false }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="#38BDF8"
            className={`${open === id ? "rotate-180" : ""} h-5 w-5 transition-transform ${isLoading ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300 print:hidden`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
    );
};


const useRecentPrompts = (user) => {
    const [recentPrompts, setRecentPrompts] = useState([]);

    useEffect(() => {
        const fetchRecentPrompts = async () => {
            if (!user?.uid) return;

            const db = getFirestore();
            const promptsRef = collection(db, "gen-prompt-cache");

            try {
                const q = query(
                    promptsRef,
                    where("userId", "==", user.uid),
                    orderBy("timestamp", "desc"),
                    limit(5)
                );

                const querySnapshot = await getDocs(q);
                const prompts = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                setRecentPrompts(prompts);
            } catch (error) {
                console.error("Error fetching recent prompts:", error);
            }
        };

        fetchRecentPrompts();
    }, [user]);

    //return recentPrompts;
    return { recentPrompts, setRecentPrompts };
};

// Add new Context Analysis section
const ContextAnalysisSection = ({ contextAnalysis, loading }) => (
    <div className="mt-4">
        <h2 className="text-lg font-semibold text-zinc-100 mb-3">Story Context Analysis</h2>
        {loading ? (
            <Skeleton height={100} />
        ) : contextAnalysis && (
            <div className="space-y-6">
                {/* Key Themes */}
                <div className="bg-zinc-800/50 rounded p-4">
                    <div className="text-sky-400 font-medium mb-2">Key Themes</div>
                    <ul className="list-disc pl-4 space-y-1">
                        {contextAnalysis.themes.map((theme, idx) => (
                            <li key={idx} className="text-zinc-400">{theme}</li>
                        ))}
                    </ul>
                </div>

                {/* Turning Points */}
                <div className="bg-zinc-800/50 rounded p-4">
                    <div className="text-sky-400 font-medium mb-2">Critical Turning Points</div>
                    <ul className="list-disc pl-4 space-y-1">
                        {contextAnalysis.turningPoints.map((point, idx) => (
                            <li key={idx} className="text-zinc-400">{point}</li>
                        ))}
                    </ul>
                </div>

                {/* Value Propositions */}
                <div className="bg-zinc-800/50 rounded p-4">
                    <div className="text-sky-400 font-medium mb-2">Value Propositions</div>
                    <div className="space-y-3">
                        <div>
                            <h4 className="text-zinc-300 font-medium">Business</h4>
                            <p className="text-zinc-400">{contextAnalysis.valueProps.business}</p>
                        </div>
                        <div>
                            <h4 className="text-zinc-300 font-medium">Technical</h4>
                            <p className="text-zinc-400">{contextAnalysis.valueProps.technical}</p>
                        </div>
                        <div>
                            <h4 className="text-zinc-300 font-medium">Customer</h4>
                            <p className="text-zinc-400">{contextAnalysis.valueProps.customer}</p>
                        </div>
                    </div>
                </div>

                {/* Technology Highlights */}
                <div className="bg-zinc-800/50 rounded p-4">
                    <div className="text-sky-400 font-medium mb-2">Technology Implementation Highlights</div>
                    <ul className="list-disc pl-4 space-y-1">
                        {contextAnalysis.techHighlights.map((highlight, idx) => (
                            <li key={idx} className="text-zinc-400">{highlight}</li>
                        ))}
                    </ul>
                </div>
            </div>
        )}
    </div>
);



// function SomePage() {
//   return (
//     <div className="container mx-auto">
//       <h1 className="text-2xl font-bold mb-4">Website Crawler Tool</h1>
//       <WebCrawlerModal />
//     </div>
//   );
// }



export default function CompAIStoryBoardv2() {
    const { user } = UserAuth();
    const location = useLocation();

    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [activeScenarioTab, setActiveScenarioTab] = useState(0);
    const [ignoreProblemValidationForBrainstorm, setIgnoreProblemValidationForBrainstorm] = useState(false);

    //    let intelligenceFoundation;

    const ElevenLabsAPIKey = 'sk_f8d3797facf090b36877ce8b64da0a567b894125d3a71931';

    // Load default story tone settings, then override with user settings
    const [storyTone, setStoryTone] = useState({
        research: 'Casual',
        story: 'Casual',
        storyTone: 'Casual',
        storyLength: '3',
        storyIntensity: 'a regular day, nothing overly dramatic, but the product helps make it easier in important ways',
        researchDepth: 'deep',
        notificationTone: 'none'
    });




    const functions = getFunctions(app);
    if (process.env.NODE_ENV === 'development') {
        connectFunctionsEmulator(functions, "127.0.0.1", 5001);
    }

    useEffect(() => {
        const loadUserSettings = async () => {
            // console.log('loading user settings');
            // console.log('storyTone', storyTone);
            try {
                const userGetSettings = httpsCallable(functions, 'userGetSettings');
                const result = await userGetSettings();

                if (result.data.userData) {
                    setStoryTone(prevTone => ({
                        ...prevTone,
                        ...result.data.userData.storySettings
                    }));
                    //console.log('settings - from store', result.data.userData.storySettings);
                }
                else {
                    //console.log('No user settings found');
                    // setStoryTone({
                    //     research: 'Casual',
                    //     story: 'Casual',
                    //     storyTone: 'Casual',
                    //     storyLength: '3',
                    //     storyIntensity: 'a regular day, nothing overly dramatic, but the product helps make it easier in important ways',
                    //     researchDepth: 'deep',
                    //     notificationTone: 'none'
                    // });
                    setStoryTone(prevTone => ({
                        ...prevTone,
                        research: 'Casual',
                        story: 'Casual',
                        storyTone: 'Casual',
                        storyLength: '3',
                        storyIntensity: 'a regular day, nothing overly dramatic, but the product helps make it easier in important ways',
                        researchDepth: 'deep',
                        notificationTone: 'none'
                    }));
                    //console.log('settings - fallback', storyTone);
                }
            } catch (error) {
                //console.error('Error loading settings:', error);
            }
        };

        loadUserSettings();
    }, []);


    const [maxDeepData, setMaxDeepData] = useState(null);

    // useEffect(() => {
    //     console.log("maxDeepData state updated:", maxDeepData);
    // }, [maxDeepData]);





    useEffect(() => {
        ////console.log('storyTone', storyTone);
    }, [storyTone]);

    // Add handler for tone changes
    const handleToneChange = (newToneSettings) => {
        //      //console.log('newToneSettings', newToneSettings);
        setStoryTone(newToneSettings);
    };

    //const baseColor = '#1E1E25';
    const baseColor = '#34343A';
    const highlightColor = '#2C2C30';
    const [loading, setLoading] = useState(false);
    const [uploadStatus, setUploadStatus] = useState(null);
    const [allowGeneration, setAllowGeneration] = useState(true);
    const [researchData, setResearchData] = useState({
        customerInsights: null,
        productInsights: null,
        podcastInsights: null,
        //researchDeepData: null
    });
    const [researchDeepData, setResearchDeepData] = useState(null);
    const [storyData, setStoryData] = useState({
        introduction: null,
        scenes: { scenes: [] },
        conclusion: null,
        personas: []
    });
    const [isNavVisible, setIsNavVisible] = useState(true);
    const [error, setError] = useState(null);
    const [personaData, setPersonaData] = useState(null);
    const [salesAnalysisData, setSalesAnalysisData] = useState(null);
    const [viewMode, setViewMode] = useState("detailed");
    const [activeTab, setActiveTab] = useState('insights');
    const [brandLogoData, setBrandLogoData] = useState(null);
    const [eli5Data, setEli5Data] = useState(null);
    const [eli5ResearchData, setEli5ResearchData] = useState(null);
    const [eli5DataBusiness, setEli5DataBusiness] = useState(null);
    const [eli5DataIndustry, setEli5DataIndustry] = useState(null);
    const [eli5StakeholdersData, setEli5StakeholdersData] = useState(null);
    const [contentTone, setContentTone] = useState('casual');
    //const [jobsELI5, setJobsELI5] = useState(null);
    const [currentStep, setCurrentStep] = useState("Ready");
    const [currentFormStep, setCurrentFormStep] = useState(4);
    const [openPaths, setOpenPaths] = useState(false);

    const [storySpeakerData, setStorySpeakerData] = useState(null);
    const [storySpeakerSummaryResult, setStorySpeakerSummaryResult] = useState(null);
    const [storyChaptersData, setStoryChaptersData] = useState(null);
    const [businessTransformationResult, setBusinessTransformationResult] = useState(null);
    const [businessCostOfInactionResult, setBusinessCostOfInactionResult] = useState(null);
    const [businessModelData, setBusinessModelData] = useState(null);
    const [intelligenceFoundation, setIntelligenceFoundation] = useState(null);
    const [activeTabStart, setActiveTabStart] = useState(null);
    const [businessValueData, setBusinessValueData] = useState(null);
    const [competitiveAnalysisData, setCompetitiveAnalysisData] = useState(null);
    const [caseStudiesData, setCaseStudiesData] = useState(null);
    const [competitiveAnalysisResult, setCompetitiveAnalysisResult] = useState(null);
    const [displayProblemError, setDisplayProblemError] = useState(false);

    const [newsViewMode, setNewsViewMode] = useState(() => getViewModePreference('news')); // 'grid' or 'carousel'
    const [industryViewMode, setIndustryViewMode] = useState(() => getViewModePreference('industry')); // 'grid' or 'carousel'

    const [modalData, setModalData] = useState(null);

    //const [apiEndpoint, setApiEndpoint] = useState(apiEndpoint +  '');
    //const [apiEndpoint, setApiEndpoint] = useState('http://127.0.0.1:5001/brevit3-57b00/us-central1/');
    const [apiEndpoint, setApiEndpoint] = useState('https://us-central1-brevit3-57b00.cloudfunctions.net/');

    // const [formData, setFormData] = useState({ 
    //     promptCompanyName: 'Procore',
    //     promptProductName: 'Project Management',
    //     promptCustomerName: 'Turner Construction',
    //     promptCustomerRole: 'Director',
    //     promptCustomerProblem: 'accelerating data center construction',

    //     //website: 'https://www.webflow.com',
    //     website: 'https://webflow.com/platform',
    //     competitor: 'https://wpvip.com/',

    // });





    //    const { user } = useAuth();

    const [formData, setFormData] = useState({
        // ... existing code ...
        promptCompanyName: '',
        promptProductName: '',
        promptCustomerName: '',
        promptCustomerRole: '',
        promptCustomerProblem: '',
        // ... existing code ...
    });

    // Update form data when user changes
    // useEffect(() => {
    //     if (user?.email === 'john.brunswick@gmail.com') {
    //         setFormData(prevData => ({
    //             ...prevData,
    //             promptCompanyName: 'Procore',
    //             promptProductName: 'Project Management',
    //             promptCustomerName: 'Turner Construction',
    //             promptCustomerRole: 'Director',
    //             promptCustomerProblem: 'accelerating data center construction',
    //             website: '',
    //             competitor: '',
    //         }));
    //     }
    // }, [user]);





    const [producedStory, setProducedStory] = useState({
        contextAnalysis: null,
        title: null,
        opening: null,
        middleScenes: [],
        closing: null
    });
    const [storyVisualizationData, setStoryVisualizationData] = useState(null);
    //const [storyChaptersData, setStoryChaptersData] = useState(null);
    const [producedResult, setProducedResult] = useState(null);


    const [apiCalls, setApiCalls] = useState({
        research: false,
        eli5Research: false,
        persona: false,
        story: false,
        producer: false,
        talkTrack: false,
        salesAnalysis: false,
        wardrobe: false,
        businessNews: false,
        eli5Business: false,
        industryTrends: false,
        eli5Industry: false,
        storyChapters: false,
        //messagingResearch: false,
        mediaResearch: false,
        eli5Media: false,
        businessAnalysis: false,
        storySpeaker: false,
        storySpeakerSummary: false,
        maxDeep: false,
        maxDeepData: false,
        deepLanguage: false,
        businessValue: false,
        eli5BusinessValue: false,
        caseStudies: false,
        competitiveAnalysis: false
    });


    const [apiCallsCompleted, setApiCallsCompleted] = useState({
        research: false,
        eli5Research: false,
        persona: false,
        story: false,
        producer: false,
        talkTrack: false,
        salesAnalysis: false,
        wardrobe: false,
        businessNews: false,
        eli5Business: false,
        industryTrends: false,
        eli5Industry: false,
        storyChapters: false,
        //messagingResearch: false,
        mediaResearch: false,
        eli5Media: false,
        businessAnalysis: false,
        storySpeaker: false,
        storySpeakerSummary: false,
        maxDeep: false,
        maxDeepData: false,
        deepLanguage: false,
        businessValue: false,
        eli5BusinessValue: false,
        businessTransformation: false,
        caseStudies: false,
        competitiveAnalysis: false
    });

    // Calculate progress based on completed API calls (after apiCallsCompleted is declared)
    const calculateProgress = () => {
        const totalCalls = [
            'research', 'businessNews', 'eli5Business', 'deepLanguage', 'industryTrends', 
            'eli5Industry', 'persona', 'story', 'producer', 'storyChapters', 
            'businessAnalysis', 'eli5BusinessValue', 'storySpeaker', 'storySpeakerSummary', 
            'businessTransformation', 'salesAnalysis', 'competitiveAnalysis', 'caseStudies'
        ];
        
        const completedCalls = totalCalls.filter(call => apiCallsCompleted[call]);
        return {
            completed: completedCalls.length,
            total: totalCalls.length,
            percentage: (completedCalls.length / totalCalls.length) * 100
        };
    };

    const progress = calculateProgress();

    const [talkTrackData, setTalkTrackData] = useState(null);
    const [timer, setTimer] = useState(0);
    const [isTimerRunning, setIsTimerRunning] = useState(false);
    const [sectionTimes, setSectionTimes] = useState({
        research: null,
        eli5Research: null,
        persona: null,
        story: null,
        producer: null,
        talkTrack: null,
        salesAnalysis: null,
        wardrobe: null,
        businessNews: null,
        eli5Business: null,
        industryTrends: null,
        eli5Industry: null,
        storyChapters: null,
        //messagingResearch: null,
        mediaResearch: null,
        eli5Media: null,
        businessAnalysis: null,
        storySpeaker: null,
        storySpeakerSummary: null,
        maxDeep: null,
        maxDeepData: null,
        deepLanguage: null,
        businessValue: null,
        eli5BusinessValue: null,
        caseStudies: null,
        competitiveAnalysis: null
    });
    //    const [wardrobeData, setWardrobeData] = useState(null);
    const [businessNewsData, setBusinessNewsData] = useState(null);
    const [industryTrendsData, setIndustryTrendsData] = useState(null);
    const [podcastGenerationData, setPodcastGenerationData] = useState(null);
    const [businessAnalysisData, setBusinessAnalysisData] = useState(null);
    const [showProgressBar, setShowProgressBar] = useState(false);
    const [eli5DataMedia, setEli5DataMedia] = useState(null);
    const [eli5BusinessValueData, setEli5BusinessValueData] = useState(null);


    //    console.log("maxDeepData state initialized:", maxDeepData);



    const [isKanbanModalOpen, setIsKanbanModalOpen] = useState(false);
    const [researchCompetitorData, setResearchCompetitorData] = useState(null);
    const [isResearchCompetitorLoading, setIsResearchCompetitorLoading] = useState(false);
    //    const [expandedSections, setExpandedSections] = useState({});
    const [showConfetti, setShowConfetti] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    // View mode change handlers with preference persistence
    const handleNewsViewModeChange = (newMode) => {
        setNewsViewMode(newMode);
    };

    const handleIndustryViewModeChange = (newMode) => {
        setIndustryViewMode(newMode);
    };

    // Add timer effect
    useEffect(() => {
        let intervalId;
        if (isTimerRunning) {
            intervalId = setInterval(() => {
                setTimer(prev => prev + 10); // Update every 10ms
            }, 10);
        }
        return () => clearInterval(intervalId);
    }, [isTimerRunning]);

    // Format time function
    const formatTime = (time) => {
        const minutes = Math.floor(time / 60000);
        const seconds = Math.floor((time % 60000) / 1000);
        const milliseconds = Math.floor((time % 1000) / 10);
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}.${milliseconds.toString().padStart(2, '0')}`;
    };

    const playSound = () => {
        if (storyTone.notificationTone === 'none') return;
        const audio = new Audio(`/media/notifications/${storyTone.notificationTone}`);
        audio.play();
    };



    // Add new state variable near the top where other states are defined
    const [researchProductData, setResearchProductData] = useState(null);
    const [isResearchProductLoading, setIsResearchProductLoading] = useState(false);


    const [exampleProblems] = useState([
        "reducing customer churn by 25% in the next quarter",
        "streamlining their order fulfillment process to improve delivery times",
        "implementing a scalable solution for managing remote team collaboration"
    ]);

    const handleResearchProductDetails = async () => {
        setIsResearchProductLoading(true);
        try {
            // First API call
            const [productResponse] = await Promise.all([
                fetch(apiEndpoint + 'jobsCrawlWebsite', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        ...formData,
                        website: formData.website,
                        maxPages: 20,
                        competitor: ''
                    })
                })
            ]);

            if (!productResponse.ok) {
                throw new Error(`HTTP error! status: ${productResponse.status}`);
            }

            const [productData] = await Promise.all([
                productResponse.json()
            ]);

            // Second API call after first one completes
            const productResponseCompany2 = await fetch(apiEndpoint + 'jobsCrawlWebsite', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    ...formData,
                    website: formData.competitor,
                    maxPages: 20,
                    competitor: ''
                })
            });

            if (!productResponseCompany2.ok) {
                throw new Error(`HTTP error! status: ${productResponseCompany2.status}`);
            }

            const competitorData = await productResponseCompany2.json();

            //console.log('Product Data:', productData);
            //console.log('Competitor Data:', competitorData);

            setResearchProductData(productData);
            setResearchCompetitorData(competitorData);
        } catch (error) {
            //console.error('Error fetching research details:', error);
            setError(error.message);
        } finally {
            setIsResearchProductLoading(false);
            setIsResearchCompetitorLoading(false);
        }
    };

    const { recentPrompts, setRecentPrompts } = useRecentPrompts(user);

    const validateFormFields = (formDataToCheck) => {
        const requiredFields = [
            'promptCompanyName',
            'promptProductName',
            'promptCustomerRole',
            'promptCustomerName',
            'promptCustomerProblem'
        ];

        const emptyFields = requiredFields.filter(field => !formDataToCheck[field]);
        return emptyFields;
    };

    const [touchedFields, setTouchedFields] = useState({});

    const handleFieldBlur = (e) => {
        const { name } = e.target;
        setTouchedFields(prev => ({
            ...prev,
            [name]: true
        }));
    };



    const [learningDocuments, setLearningDocuments] = useState([]);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [currentUser, setCurrentUser] = useState(null);



    useEffect(() => {
        const fetchCurrentUser = async () => {
            if (!user?.uid) return;

            try {
                const userDocRef = doc(db, "users", user.uid);
                const userDocSnap = await getDoc(userDocRef);

                if (userDocSnap.exists()) {
                    setCurrentUser({
                        id: userDocSnap.id,
                        ...userDocSnap.data()
                    });
                } else {
                    //      console.log("No user document found for this user ID");
                }
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        };

        //        console.log('fetching current user');
        fetchCurrentUser();
    }, [recentPrompts]);



    const [groundingDocs, setGroundingDocs] = useState([])

    // Add this effect to fetch documents based on user's organization
    useEffect(() => {

        const fetchLearningDocuments = async () => {
            if (!currentUser || !currentUser.org) return;

            try {
                //console.log('fetching learning documents');
                // const userOrgIds = Object.keys(currentUser.org).filter(
                //     orgId => currentUser.org[orgId] === true
                // );

                const userOrgId = Number(currentUser.org[0]);

                // Log the type to verify
                //      console.log('userOrgId', userOrgId, 'type:', typeof userOrgId);

                if (userOrgId === null) return;

                const q = query(
                    collection(db, 'gen-documents'),
                    where('org', '==', userOrgId) // Make sure this is a number, not a string
                );

                //console.log('q', q);

                // Execute the query
                const querySnapshot = await getDocs(q);

                // Map the documents to include their IDs
                const filteredDocs = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));


                // console.log('Filtered documents:', filteredDocs);
                setLearningDocuments(filteredDocs);
                setGroundingDocs(filteredDocs);
            } catch (error) {
                //console.error("Error fetching learning documents:", error);
            }
        };
        setTimeout(() => {
            fetchLearningDocuments();
        }, 1000);
    }, [currentUser]);



    //useEffect(() => {


    //}, []);


    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        try {
            setUploadStatus('uploading');

            // Read the file as base64
            const reader = new FileReader();
            reader.onload = async (e) => {
                const base64Content = e.target.result.split(',')[1]; // Remove data URL prefix

                try {
                    // Get Firebase Functions instance
                    const functions = getFunctions();
                    const processLearnDocument = httpsCallable(functions, 'processLearnDocument');

                    // Call the Cloud Function
                    const result = await processLearnDocument({
                        documentContent: base64Content
                    });

                    setUploadStatus('success');

                    // Handle the processed markdown result
                    if (result.data.markdown) {
                        // You can store this in your state or handle it as needed
                        //      console.log('Processed markdown:', result.data.markdown);
                    }

                } catch (error) {
                    console.error('Error processing document:', error);
                    setUploadStatus('error');
                }
            };

            reader.readAsDataURL(file);

        } catch (error) {
            console.error('Error handling file upload:', error);
            setUploadStatus('error');
        }
    };



    const [viewingDocument, setViewingDocument] = useState(null);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);

    const handleViewDocument = (doc) => {
        setViewingDocument(doc);
        setIsViewModalOpen(true);
    };


    const generateStory = async (e) => {
        if (!allowGeneration) return;

        e.preventDefault();

        const storyParams = {
            // State values
            formData,
            storyTone,
            user,
            apiEndpoint,
            groundingDocs,
            recentPrompts,

            // State setters
            setIsFormSubmitted,
            setError,
            setTimer,
            setIsTimerRunning,
            setLoading,
            setShowProgressBar,
            setApiCalls,
            setCurrentStep,
            setApiCallsCompleted,
            setSectionTimes,
            setResearchData,
            setResearchDeepData,
            setBusinessModelData,
            setBusinessNewsData,
            setIndustryTrendsData,
            setEli5DataBusiness,
            setEli5DataIndustry,
            setMaxDeepData,
            setPersonaData,
            setStoryData,
            setProducedResult,
            setProducedStory,
            setStoryVisualizationData,
            setStoryChaptersData,
            setBusinessAnalysisData,
            setEli5BusinessValueData,
            setStorySpeakerData,
            setStorySpeakerSummaryResult,
            setBusinessTransformationResult,
            setBusinessCostOfInactionResult,
            setSalesAnalysisData,
            setModalData,
            setIntelligenceFoundation,
            setOpenPaths,
            setRecentPrompts,
            setOpenSections,
            setCompetitiveAnalysisData, // Added this line
            setCaseStudiesData,
            setCompetitiveAnalysisResult,

            // Helper functions/instances from Component
            handleOpen,
            playSound,
            functions,
            db,
            logCustomEvent,
        };

        try {
            await executeGenerateStory(storyParams);
        } catch (error) {
            console.error("Error calling executeGenerateStory from component:", error);
            // The service should ideally set specific errors.
            // This is a fallback if the service call itself fails or an unhandled error propagates.
            // setError(`Story generation process failed: ${error.message || 'Unknown error'}`);
            // Ensure loading states are reset by the service's finally block.
        }
    };


    // useEffect(() => {
    //     //console.log('Wardrobe Data:', wardrobeData);
    // }, [wardrobeData]);



    //const [storyBiteData, setStoryBiteData] = useState(null);

    const generateStoryBite = async (item) => {

        const randomVersion = Math.floor(Math.random() * 100000);
        logCustomEvent('gen_story_bite', {})

        const storyBiteResponse = await fetch(apiEndpoint + 'jobsStoryBite', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                producedWrapper: producedResult,
                story: storyData,
                storyData: storyData,
                personaData: personaData,
                researchData: researchData,
                businessNewsData: businessNewsData,
                industryTrendsData: industryTrendsData,
                formData: formData,
                transcriptData: transcriptData,
                version: randomVersion,
                executiveInterview: researchData.podcastInsights,
                tone: storyTone.story,
                storyIntensity: storyTone.storyIntensity,
                storyLength: storyTone.storyLength,
                item: item
            }),
        });

        const storyBiteResult = await storyBiteResponse.json();
        //console.log('StoryBite Generation API Response:', storyBiteResult);
        //setStoryBiteData(storyBiteResponse);
        playSound(); // Play sound after storyBite generation call
        return storyBiteResult;
    }


    const getHeadingClass = (apiCall, data) => {
        if (apiCall) return "text-zinc-600";
        if (data) return "text-zinc-100";
        return "text-zinc-600";
    };

    const formatSectionTime = (ms) => {
        if (ms === null) return '';
        const seconds = Math.floor(ms / 1000);
        const milliseconds = ms % 1000;
        return `${seconds}.${milliseconds.toString().padStart(3, '0')}s`;
    };

    const storyPathRef = useRef(null); // Explicitly initialize with null
    const reactToPrintFn = useReactToPrint({
        contentRef: storyPathRef,
        onBeforeGetContent: () => {
            //console.log("Before getting content");
        },
        onAfterPrint: () => console.log("Printing completed"),
        onPrintError: (error) => console.error("Print error:", error),
        pageStyle: `
            @page {
                size: auto;
                margin: 20mm 15mm 25mm 15mm;
            }
            @media print {
                html, body {
                    height: 100%;
                    margin: 0 !important;
                    padding: 0 !important;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }
                
                /* Header that appears on every page */
                .page-header {
                    position: fixed;
                    top: 5mm;
                    left: 15mm;
                    right: 15mm;
                    height: 10mm;
                    text-align: right;
                    
                    color: #666;
                    border-bottom: 1px solid #eee;
                    padding-bottom: 3mm;
                }
                
                /* Content positioning to account for header and footer */
                .print-content {
                    margin-top: 15mm;
                    margin-bottom: 20mm;
                }
                
                /* Cover page styling */
                .cover-page {
                    display: block !important;
                    height: calc(100vh - 45mm); /* Account for margins */
                    width: calc(100% - 30mm); /* Account for margins */
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                    page-break-after: always;
                    position: relative;
                    margin: 20mm 15mm;
                }
                .cover-page-logo {
                    max-width: 200px;
                    margin-bottom: 40px;
                }
                .cover-page-title {
                    margin-bottom: 20px;
                }
                .cover-page-subtitle {
                    margin-bottom: 40px;
                }
                .cover-page-details {
                    margin-bottom: 10px;
                }
                
                /* Footer styling */
                .page-footer {
                    display: block !important;
                    position: fixed;
                    bottom: 5mm; /* Position within the margin area */
                    left: 15mm;
                    right: 15mm;
                    height: 15mm;
                    padding: 3mm 0;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    
                    border-top: 1px solid #ddd;
                    background-color: white;
                }
                .page-footer-left {
                    display: flex;
                    align-items: center;
                }
                .page-footer-left img {
                    height: 15px;
                    margin-right: 10px;
                }
                .page-footer-right::after {
                    content: "Page " counter(page) " of " counter(pages);
                    margin-left: 10px;
                }
            }
        `,
        documentTitle: `StoryPath_${formData.promptCustomerName || 'Customer'}_Research_${formData.promptProductName || 'Product'}_${new Date().toLocaleDateString().replace(/\//g, '_')}`,
    });

    const injectFooter = useCallback(() => {
        const printContainer = storyPathRef.current;
        if (!printContainer) {
            //console.error("Print container not found");
            return;
        }

        //console.log("Injecting header, footer and cover page");

        const currentYear = new Date().getFullYear();
        const currentDate = new Date().toLocaleDateString();

        // Add a wrapper div to properly position content
        const contentWrapper = document.createElement('div');
        contentWrapper.className = 'print-content';

        // Move all existing children to the wrapper
        while (printContainer.firstChild) {
            contentWrapper.appendChild(printContainer.firstChild);
        }

        // Create header
        const header = document.createElement('div');
        header.className = 'page-header';
        header.innerHTML = `
            <span>StoryPath Report - ${formData.promptCompanyName || 'Company'}</span>
        `;


        // Create footer
        const footer = document.createElement('div');
        footer.className = 'page-footer';
        footer.style.display = 'none'; // Hide in normal view, show only in print
        footer.innerHTML = `
            <div className="page-footer-left">
                <img src="/logo.png" alt="StoryPath Logo" />
                <span>© ${currentYear} StoryPath</span>
            </div>
            <div className="page-footer-right">
                <span>Customer: ${formData.promptCompanyName || 'N/A'} | Date: ${currentDate}</span>
            </div>
        `;

        // Add elements to the print container in the correct order
        printContainer.appendChild(header);
        printContainer.appendChild(coverPage);
        printContainer.appendChild(contentWrapper);
        printContainer.appendChild(footer);

        return () => {
            // Return cleanup function that restores the original structure
            if (header && header.parentNode) header.parentNode.removeChild(header);
            if (footer && footer.parentNode) footer.parentNode.removeChild(footer);

            // Move content back from wrapper to container
            if (contentWrapper && contentWrapper.parentNode) {
                while (contentWrapper.firstChild) {
                    printContainer.appendChild(contentWrapper.firstChild);
                }
                contentWrapper.parentNode.removeChild(contentWrapper);
            }

            if (coverPage && coverPage.parentNode) coverPage.parentNode.removeChild(coverPage);

            //console.log("Cleaned up print elements");
        };
    }, [formData]);

    // Modified print function to inject the footer and cover page
    const handlePrint = useCallback(() => {
        //console.log("Print initiated");

        // First inject the elements
        const cleanup = injectFooter();

        // Give browser time to render the elements before printing
        setTimeout(() => {
            //console.log("Starting print after delay");
            reactToPrintFn();

            // Don't clean up immediately - wait until after printing is complete
            // The onAfterPrint callback would be ideal, but as a fallback:
            setTimeout(() => {
                if (cleanup) {
                    //console.log("Running cleanup");
                    cleanup();
                }
            }, 2000); // Longer timeout to ensure printing completes
        }, 300); // Delay to ensure DOM is updated
    }, [injectFooter, reactToPrintFn]);

    const businessNewsRef = useRef();
    const producedStoryRef = useRef();
    const researchRef = useRef();
    const industryTrendsRef = useRef();
    const personasRef = useRef();
    const castRef = useRef();
    const draftStoryRef = useRef();
    const talkTrackRef = useRef();
    const salesAnalysisRef = useRef();
    const businessAnalysisRef = useRef();

    const [transcriptResults, setTranscriptResults] = useState([]);
    const [transcriptData, setTranscriptData] = useState([]);

    // Initialize usePDF hook
    const { toPDF: generatePDF } = usePDF();




    const [open, setOpen] = useState(0);

    //const handleOpen = (value) => setOpen(open === value ? 0 : value);

    // Replace the single open state with an array
    const [openSections, setOpenSections] = useState([]);

    //    Update the handleOpen function
    const handleOpen = (value, inplace = 0) => {
        setOpenSections(prev => {
            if (prev.includes(value)) {
                return prev.filter(item => item !== value);
            } else {
                return [...prev, value];
            }
        });
        if (inplace === 1) {
            setTimeout(() => {
                const accordion = document.querySelector(`[data-accordion-id="${value}"]`);
                if (accordion) {
                    accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 100);
        }
    };

    const generateSectionPDF = (sectionRef, sectionName) => {
        if (sectionRef.current) {
            generatePDF({
                filename: `${formData.promptCompanyName}_${sectionName}.pdf`,
                targetRef: sectionRef.current
            });
        } else {
            //console.error("Unable to get the target element.");
        }
    };




    const storyCards = [
        {
            id: 'generate',
            bigTitle: 'Deep Dive',
            title: 'Find Your Path - Deep Opportunity Insights',
            description: 'We do the heavy lifting and generate a story based on your needs and target audience',
            icon: 'M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z',
            provides: [
                '3 Product Stories - Summary, Day-to-Day, and Deep Dive',
            ],
            benefits: [
                //'Uncover opportunities found through deep, deal-focused research',
                'Connect deeply - learn your customer\'s business and language',
                'Find opportunities relevant to your buyer\'s strategy, news, and trends',
                'Listen to PathCasts and export insights & stories'
            ],
            roadmap: [
                'Collaborate with your team',
            ],
            linktext: 'Discover Paths within an Opportunity',
            onClick: () => {/* handle generate story */ }
        },
        {
            id: 'blank',
            bigTitle: 'Experience',
            title: 'Immersive Theater Experience',
            description: 'Bring your story to life with an immersive visual experience that combines people, process, technology, and business value',
            provides: [
                'Asset - Create and Share',
            ],
            benefits: [
                'Captivate audiences with interactive, cinematic experiences',
                'Visualize people, process, technology and business value around your live applications',
                'On-Demand delivery and analytics to understand your audience',
            ],
            roadmap: [
                'Import Your Existing Presentations',
            ],
            icon: 'M12 4v16m8-8H4', // Plus icon
            linktext: 'Create Theater Experience',
            onClick: () => {/* handle blank story */ }
        },

    ];

    const [storypathType, setStorypathType] = useState(null);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const type = params.get('type');
        if (type === 'generate' || type === 'blank') {
            setStorypathType(type);
        }
    }, [location.search]);

    const [challenges, setChallenges] = useState([]);
    const [loadingChallenges, setLoadingChallenges] = useState(false);
    const [showChallengesModal, setShowChallengesModal] = useState(false);

    // Add this function to call jobsChallengeFinder
    const findCustomerChallenges = async () => {
        try {
            setLoadingChallenges(true);

            // Get the necessary data from formData
            const { promptProductName, promptCustomerName, promptCustomerRole, promptCompanyName } = formData;

            // Call the Firebase function
            const functionsInstance = getFunctions();
            const jobsChallengeFinderCallable = httpsCallable(functionsInstance, 'jobsChallengeFinder', { timeout: 540000 });

            const result = await jobsChallengeFinderCallable({
                productName: promptProductName,
                customerName: promptCustomerName,
                customerRole: promptCustomerRole,
                companyName: promptCompanyName
            });

            if (result.data.challenges && Array.isArray(result.data.challenges)) {
                //      console.log('challenges', result.data.challenges);
                setChallenges(result.data.challenges);

            } else {
                console.error('Invalid response format from jobsChallengeFinder');
                setChallenges([]);
            }

            // } else {
            //     console.error('Invalid response format from jobsChallengeFinder');
            //     setChallenges([]);
            // }
        } catch (error) {
            console.error('Error finding customer challenges:', error);
            setChallenges([]);
        } finally {
            setLoadingChallenges(false);
        }
    };

    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

    const [storyName, setStoryName] = useState('');
    const [storyDescription, setStoryDescription] = useState('');
    const navigate = useNavigate();
    //const { user } = UserAuth(); //useAuth();

    const [runJoyride, setRunJoyride] = useState(false);
    const [joyrideSteps, setJoyrideSteps] = useState([]);

    const handleSkipTour = async () => {
        setRunJoyride(false);
        if (user?.uid) {
            try {
                const userDocRef = doc(db, 'users', user.uid);
                // Using "onboardingTour" as the effective explainerId, stored under the 'onboarding' map.
                await updateDoc(userDocRef, {
                    'onboarding.onboardingTour': true
                });
                // console.log("User tour preference updated for onboardingTour.");
            } catch (error) {
                console.error("Error updating user tour preference for Joyride:", error);
            }
        }
    };

    const handleJoyrideCallback = (data) => {
        const { action, status } = data;

        if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status) || action === ACTIONS.CLOSE) {
            setRunJoyride(false);
            // If the tour is finished or skipped, and user exists, call handleSkipTour.
            if ((status === STATUS.FINISHED || status === STATUS.SKIPPED) && user?.uid) {
                handleSkipTour(); // Call for both finished and skipped states
            }
        }
        // console.log('Joyride callback data:', data); // For debugging
    };

    useEffect(() => {
        // Initialize Joyride steps
        setJoyrideSteps([
            {
                target: '#form-joyride-target',
                content: 'Complete this sentence to kick off your deep dive.  If you don\'t know the challenge or goal, we are here to help you to brainstorm.',
                placement: 'top',
            },
            {
                target: '#know-your-customer-joyride-target',
                content: 'As StoryPath learns and thinks about your buyer, it will share insights that help align your buyer and solution.  The stories it shares will help to boot up on your customer\'s "why".',
                placement: 'auto',
            },
            {
                target: '#build-content-joyride-target',
                content: `Grab a coffee and let StoryPath do the heavy lifting, preparing strategies and assets for you to review.  We will keep you posted on our pogress, as we get things ready for you.`,
                placement: 'auto',
            },
            {
                target: '#insights-co-creation-joyride-target',
                content: 'Once the deep dive is complete, our GTM expert intelligence, Coco, is ready to help you dig into a hypothesis summary, relevant case studies, current to future state, competitive analysis, cost of inaction, value assessment and art of the possible.  You can ask any question and any time to get the answers you need.',
                placement: 'auto',
            }
        ]);

        let timeoutId;
        const checkPreferenceAndRunJoyride = async () => {
            // Determine if UI conditions are met to show the tour
            const uiConditionsMet = storypathType === 'generate' && activeScenarioTab === 0;

            if (!uiConditionsMet) {
                setRunJoyride(false);
                return;
            }

            // If UI conditions are met, check user preference
            let userHasSkippedTour = false;
            if (user?.uid) {
                try {
                    const userDocRef = doc(db, 'users', user.uid);
                    const userDocSnap = await getDoc(userDocRef);
                    if (userDocSnap.exists()) {
                        const userData = userDocSnap.data();
                        if (userData?.onboarding?.onboardingTour) {
                            userHasSkippedTour = true;
                        }
                    }
                } catch (error) {
                    console.error("Error checking Joyride tour preference:", error);
                    // Potentially run the tour if checking preference fails, or default to not running.
                    // Current logic: if error, userHasSkippedTour remains false, so tour might run.
                }
            }

            if (userHasSkippedTour) {
                setRunJoyride(false);
            } else {
                // UI conditions met and user hasn't skipped (or no user/error in check)
                timeoutId = setTimeout(() => {
                    setRunJoyride(true);
                }, 500);
            }
        };

        checkPreferenceAndRunJoyride();

        return () => {
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [user, db, storypathType, activeScenarioTab]); // Added user and db to dependencies

    const createStory = async () => {
        if (storyName === '') {
            alert('Please enter a valid story name');
            return;
        }

        if (storyDescription === '') {
            alert('Please enter a valid story description');
            return;
        }

        let userOwnerKey = user?.uid;

        const docRef = await addDoc(collection(db, 'stories'), {
            name: storyName,
            description: storyDescription,
            userPhotoURL: user?.photoURL,
            userEmail: user?.email,
            userDisplayName: user?.displayName,
            messageUserId: user?.uid,
            backgroundMatcap: 'C8C8C8_3F3F3F_787878_5C5C5C',
            backgroundModel: 'background_plain',
            backgroundSky: 'skyBackground1',
            backgroundHeight: -5,
            layoutType: 'linear',
            layoutCircleDistance: 70,
            navigation: 'nav1',
            cameraOrbitOn: 1,
            visibility: 'private',
            previewThumb: '/media/screen/B3_New_Project.png',
            createdAt: serverTimestamp(),
            lastModified: serverTimestamp(),
            analyticsViewTotal: 0,
            analyticsLastViewed: serverTimestamp(),
            imageStoryBackground: '/media/icon/B3-Image-Placeholder.png',
            imageStoryLogo: '/media/icon/B3-Image-Placeholder.png',
            uiStyle: {
                'nav-button-bg-off': '#b3b3b3',
                'nav-button-bg-on': '#222222',
                'nav-button-text-off': '#4d4d4d',
                'nav-button-text-on': '#009ce0',
                'nav-progress-meter': '#808080',
                'nav-progress-meter-bg': '#009ce0',
                'nav-region-bg': '#111111',
                'super-highlight-color': '#009ce0',
                'super-list-icon-color': '#000000',
                'super-list-text-color': '#000000',
                'super-main-bg-color': '#111111',
                'super-main-title-color': '#009ce0',
                'super-secondary-bg-color': '#000000',
                'super-subtitle-color': '#cccccc',
            },
            role: {
                owner: [userOwnerKey],
                commenter: [userOwnerKey],
                writer: [userOwnerKey],
                reader: [userOwnerKey],
            },
        });

        // Reset form fields
        setStoryName('');
        setStoryDescription('');

        // Navigate to the new story
        navigate('/app/stories/' + docRef.id + '/edit/0');
    };

    const [selectedTemplate, setSelectedTemplate] = useState('blank');


    const handlePromptClick = (prompt) => {
        //console.log('Prompt clicked:', prompt);

        // Move to the 4th stage when a prompt is clicked
        setCurrentFormStep(4);

        // Log the action for analytics
        logCustomEvent('prompt_selectedLoad', {});

        // Update form data with the clicked prompt's values
        setFormData(prevData => ({
            ...prevData,
            promptCompanyName: prompt.promptCompanyName || '',
            promptProductName: prompt.promptProductName || '',
            promptCustomerName: prompt.promptCustomerName || '',
            promptCustomerRole: prompt.promptCustomerRole || '',
            promptCustomerProblem: prompt.promptCustomerProblem || ''
        }));

        setAllowGeneration(true);
        setError(null);
    };

    const handleDeletePrompt = async (promptId) => {
        try {
            if (!user) {
                console.error('No user logged in');
                return;
            }

            // Reference to the specific prompt document
            const db = getFirestore();
            const promptRef = doc(db, "gen-prompt-cache", promptId);
            await deleteDoc(promptRef);

            // Update local state by filtering out the deleted prompt
            setRecentPrompts(prevPrompts => prevPrompts.filter(prompt => prompt.id !== promptId));

            // Update local state by filtering out the deleted prompt
            //setRecentPrompts(prevPrompts => prevPrompts.filter(prompt => prompt.id !== promptId));
        } catch (error) {
            console.error('Error deleting prompt:', error);
            // Optionally show an error message to the user
            setError('Failed to delete prompt. Please try again.');
        }
    };


    return (

        <div className="  mx-auto  w-full
            h-[calc(100vh-180px)]  ">


            <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>

                {isKanbanModalOpen && (
                    <motion.div
                        className="absolute top-0 left-0 w-full h-full bg-black/50 z-50 p-0 flex items-center justify-center"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <motion.div
                            className="bg-zinc-900 rounded-lg w-full h-[calc(100%-48px)] m-8 relative"
                            initial={{ scale: 0.9, y: 20 }}
                            animate={{ scale: 1, y: 0 }}
                            exit={{ scale: 0.9, y: 20 }}
                            transition={{
                                type: "spring",
                                damping: 25,
                                stiffness: 300
                            }}
                        >
                            <motion.button
                                type="button"
                                onClick={() => setIsKanbanModalOpen(false)}
                                className="absolute md:top-4 right-4 bg-zinc-800 rounded-full p-2 z-50 cursor-pointer text-zinc-400 hover:text-white"
                                whileHover={{ scale: 1.1, backgroundColor: "#3f3f46" }}
                                whileTap={{ scale: 0.95 }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </motion.button>

                            <KanbanBoard
                                storyVisualizationData={storyVisualizationData}
                                storyChaptersData={storyChaptersData}
                                formData={formData}
                                personaData={personaData}
                                generateStoryBite={generateStoryBite}
                                businessTransformationResult={businessTransformationResult}
                                businessCostOfInactionResult={businessCostOfInactionResult}
                                producedResult={producedResult}
                                businessAnalysisData={businessAnalysisData}
                                salesAnalysisData={salesAnalysisData}
                                storySpeakerSummaryResult={storySpeakerSummaryResult}
                                intelligenceFoundation={intelligenceFoundation}
                                activeTabStart={activeTabStart}
                                researchData={modalData?.researchData}
                                businessModelData={modalData?.businessModelData}
                                researchDeepData={modalData?.researchDeepData}
                                businessNewsData={modalData?.businessNewsData}
                                industryTrendsData={modalData?.industryTrendsData}
                                eli5DataBusiness={modalData?.eli5DataBusiness}
                                eli5DataIndustry={modalData?.eli5DataIndustry}
                                maxDeepData={modalData?.maxDeepData}
                                eli5BusinessValue={modalData?.eli5BusinessValue}
                                caseStudiesData={caseStudiesData}
                                competitiveAnalysisResult={modalData?.competitiveAnalysisResult}
                                competitiveAnalysisResultFeeder={modalData?.competitiveAnalysisResultFeeder}
                            />
                        </motion.div>
                    </motion.div>
                )}

                <div className="grid grid-cols-2 gap-6 mb-8">
                    {storyCards.map((card) => (
                        <motion.button
                            key={card.id}
                            className={`group bg-black/10 hover:bg-black/25 rounded-t-lg p-6 text-left transition-all duration-200 
                            border-b-2 ${storypathType === card.id ? 'border-sky-400 bg-black/30' : 'border-transparent'}`}
                            onClick={() => {
                                setStorypathType(card.id);
                                logCustomEvent('nav_create_story_button_' + card.bigTitle, { tab: card.bigTitle });
                                if (card.onClick) card.onClick();
                            }}
                            whileTap={{ scale: 0.95 }}
                            whileHover={{ scale: 1.01 }}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{
                                duration: 0.2,
                                ease: "easeOut",
                                layout: { duration: 0.2 }
                            }}
                        >
                            <div className="space-x-4">
                                <div className="grid grid-cols-[auto,1fr] gap-4">
                                    <div className="px-3 pb-2 flex rounded-lg">
                                        <motion.svg
                                            className={`w-8 h-8 mt-3 ${storypathType === card.id ? 'text-sky-400' : 'text-sky-500'}`}
                                            fill="none"
                                            stroke={storypathType === card.id ? "currentColor" : "#3f3f46"}
                                            viewBox="0 0 24 24"
                                            animate={{
                                                scale: storypathType === card.id ? 1.1 : 1,
                                                color: storypathType === card.id ? "#38bdf8" : "#3f3f46"
                                            }}
                                            transition={{ duration: 0.2 }}
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={card.icon} />
                                        </motion.svg>
                                    </div>
                                    <div>
                                        <div className={`${storypathType === card.id ? 'text-orange-300' : 'text-zinc-400'} text-3xl sp-big-heading mb-2`}>{card.bigTitle}</div>
                                        <div className={`text-zinc-100 font-base 
                                        ${storypathType === null ? 'text-xl' : 'text-lg'} mb-2`}>{card.title}</div>

                                        {/* <p className="text-zinc-400 text-sm">{card.description}</p> */}
                                    </div>

                                </div>
                                <AnimatePresence>
                                    {storypathType === null && (
                                        <>
                                            <motion.div
                                                className="flex flex-col gap-2 pl-12 pt-4"
                                                initial={{ opacity: 1, height: 'auto' }}
                                                exit={{ opacity: 0, height: 0, overflow: 'hidden' }}
                                                transition={{ duration: 0.3 }}
                                            >
                                                <ul className="list-disc pl-5 text-md text-zinc-400 mb-3">
                                                    {card.benefits.map((item, index) => (
                                                        <li key={index} className="mb-1 marker:text-sky-400">{item}</li>
                                                    ))}
                                                </ul>
                                            </motion.div>
                                            <div className="text-sky-400 hover:text-sky-300 text-base pl-12 pt-4 pb-2 flex items-center">
                                                {card.linktext}
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 ml-2">
                                                    <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                                                </svg>
                                            </div>
                                        </>
                                    )}
                                </AnimatePresence>

                            </div>
                        </motion.button>
                    ))}
                </div>

                <div className="flex-auto w-full mb-6 hidden">
                    <div className="bg-black/20 p-4 rounded-lg  ">
                        <h3 className="text-zinc-100 font-medium text-lg mb-3">API Call Status</h3>
                        <div className="grid grid-cols-3 gap-4">
                            {Object.keys(apiCalls).map((key) => (
                                <div
                                    key={key}
                                    className={`p-3 rounded-lg flex items-center gap-3 ${apiCalls[key] && !apiCallsCompleted[key]
                                        ? 'bg-amber-500/20 border border-amber-500/30'
                                        : apiCallsCompleted[key]
                                            ? 'bg-green-500/20 border border-green-500/30'
                                            : 'bg-zinc-700/30 border border-zinc-700/50'
                                        }`}
                                >
                                    <div className="flex-shrink-0">
                                        {apiCalls[key] && !apiCallsCompleted[key] ? (
                                            <div className="w-3 h-3 rounded-full bg-amber-400 animate-pulse"></div>
                                        ) : apiCallsCompleted[key] ? (
                                            <svg className="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                            </svg>
                                        ) : (
                                            <div className="w-3 h-3 rounded-full bg-zinc-500"></div>
                                        )}
                                    </div>
                                    <div className="flex-1">
                                        <div className="text-sm font-medium text-zinc-100">
                                            {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                                        </div>
                                        <div className="text-xs text-zinc-400">
                                            {apiCalls[key] && !apiCallsCompleted[key]
                                                ? 'In progress'
                                                : apiCallsCompleted[key]
                                                    ? 'Completed'
                                                    : 'Waiting'}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>



                {/* {showProgressBar && ( */}
                {showProgressBar && (

                    <div className="absolute bottom-4 animate__animated animate__fadeInUp left-14 w-[calc(100%-140px)]  rounded-lg  overflow-hidden   bg-zinc-900 z-20 shadow-lg shadow-black/25">

                        <div className=" bg-black/20 p-2 ">
                            <div className="relative mt-0 w-full">
                                <div className="flex  w-full ">


                                    <div className="text-zinc-400 text-sm flex-1 h-10  border-white/10 bg-zinc-60x0/10 bxxorder rounded-lg   pr-4 pl-3">

                                        <div className="flex gap-0.5 mt-2.5  ">
                                            <div className="text-zinc-100 text-md w-56 ">
                                                {/* {currentStep} */}
                                                <StepWithShimmer currentStep={currentStep} />
                                            </div>
                                            <div className="text-zinc-400 text-md mr-2">
                                                Research
                                            </div>
                                            {[
                                                { name: 'Research', key: 'research' },
                                                { name: 'Deep Language', key: 'deepLanguage' },
                                                { name: 'Business News', key: 'businessNews' },

                                                //{ name: 'Media Analysis', key: 'eli5Media' },
                                                { name: 'Summarizing', key: 'eli5Business' },
                                                { name: 'Trends', key: 'industryTrends' },
                                                { name: 'Summarizing', key: 'eli5Industry' },
                                                { name: 'Stakeholders', key: 'persona' },
                                            ].map((step, idx) => (
                                                <div key={step.name + '-' + idx} className="flex-1 ">
                                                    <div className={`relative w-full rounded-sm  h-1 -mb-2 mt-2  ${apiCalls[step.key] ? 'bg-sky-400 pulse-sky' :
                                                        sectionTimes[step.key] ? 'bg-sky-300' : 'bg-white/10'
                                                        }`}
                                                        title={`${step.name}: apiCalls=${!!apiCalls[step.key]}, sectionTimes=${!!sectionTimes[step.key]}, key=${step.key}`}
                                                    >
                                                    </div>
                                                    <div className="text-center text-xs">
                                                    </div>
                                                </div>
                                            ))}

                                            <div className="text-zinc-400 text-md ml-12 mr-2">
                                                Story
                                            </div>

                                            {[
                                                { name: 'Brainstorm', key: 'story' },
                                                { name: 'Framing', key: 'producer' },
                                                { name: 'Chapters', key: 'storyChapters' },

                                                { name: 'Talktrack', key: 'storySpeaker' },
                                                { name: 'Story Summary', key: 'storySpeakerSummary' },
                                                { name: 'Pitch Analysis', key: 'salesAnalysis' },


                                            ].map((step, idx) => (
                                                <div key={step.name + '-' + idx} className="flex-1 ">
                                                    {/* {step.name == 'Brainstorm' && (
                                                        <div className="text-zinc-50 text-md col-span-1 mt-3">
                                                            Story
                                                        </div>
                                                    )} */}
                                                    <div className={`relative w-full rounded-sm  h-1 -mb-2 mt-2  ${apiCalls[step.key] ? 'bg-sky-400 pulse-sky' :
                                                        sectionTimes[step.key] ? 'bg-sky-300' : 'bg-white/10'
                                                        }`}>
                                                    </div>
                                                    <div className="text-center">
                                                        <div className={`font-base mt-4 text-xs ${apiCalls[step.key] ? 'text-zinc-100' :
                                                            sectionTimes[step.key] ? 'text-zinc-100' :
                                                                'text-zinc-600'
                                                            }`}>
                                                        </div>
                                                        {/* {step.name}
                                                        
                                                        {sectionTimes[step.key] && (
                                                            <span className="text-xs text-zinc-400">
                                                                {formatSectionTime(sectionTimes[step.key])}
                                                            </span>
                                                        )} */}
                                                    </div>
                                                </div>
                                            ))}


                                            <div className="text-zinc-400 text-md ml-12 mr-2">
                                                Value
                                            </div>

                                            {[
                                                { name: 'Business Analysis', key: 'businessAnalysis' },
                                                //{ name: 'Business Value', key: 'businessValue' },


                                            ].map((step, idx) => (
                                                <div key={step.name + '-' + idx} className="flex-1 ">
                                                    {/* {step.name == 'Brainstorm' && (
                                                        <div className="text-zinc-50 text-md col-span-1 mt-3">
                                                            Story
                                                        </div>
                                                    )} */}
                                                    <div className={`relative w-full rounded-sm  h-1 -mb-2 mt-2  ${apiCalls[step.key] ? 'bg-sky-400 pulse-sky' :
                                                        sectionTimes[step.key] ? 'bg-sky-300' : 'bg-white/10'
                                                        }`}>
                                                    </div>
                                                    <div className="text-center">
                                                        <div className={`font-base mt-4 text-xs ${apiCalls[step.key] ? 'text-zinc-100' :
                                                            sectionTimes[step.key] ? 'text-zinc-100' :
                                                                'text-zinc-600'
                                                            }`}>
                                                        </div>
                                                        {/* {step.name}
                                                        
                                                        {sectionTimes[step.key] && (
                                                            <span className="text-xs text-zinc-400">
                                                                {formatSectionTime(sectionTimes[step.key])}
                                                            </span>
                                                        )} */}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>


                                    <div className="flex gap-2 items-center self-start  ml-14">
                                        {openPaths ?
                                            <>
                                                <div>
                                                    <button
                                                        type="button"
                                                        onClick={reactToPrintFn}
                                                        className="group bg-zinc-900 mx-auto hover:bg-zinc-800 text-zinc-400 hover:text-white py-2.5 px-3 rounded-md text-sm flex items-center gap-2 h-full"
                                                    >
                                                        <img src="/util/app/b3-admin-export.svg" className="h-5 content-center opacity-50 group-hover:opacity-100" /> <span className="group-hover:text-white">Export Insights</span>
                                                    </button>
                                                </div>
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        logCustomEvent('open_storypaths_modal');
                                                        //setActiveScenarioTab(0);
                                                        //setActiveTabStart(0);
                                                        setActiveTabStart('conversation');
                                                        setIsKanbanModalOpen(true);
                                                    }}
                                                    className="bg-zinc-900 mx-auto hover:bg-zinc-800 text-purple-300 py-2.5 px-3 rounded-md text-sm flex items-center gap-2"
                                                >
                                                    <img src="/util/app/b3-admin-conversation-kb-2.svg" className="h-5 content-center  " /> <span className="group-hover:text-purple-300 font-bold">Ask Anything</span>
                                                </button>
                                            </>
                                            :
                                            <>
                                                <div>
                                                    <button
                                                        type="button"
                                                        //onClick={reactToPrintFn}
                                                        className="animate-shimmer bg-gradient-to-r from-[#121216] via-[#1e1e25] to-[#121216] bg-[length:200%_100%]  text-zinc-700  mx-auto  text-zinc-400   py-2.5 px-3 rounded-md text-sm flex items-center gap-2 h-full cursor-not-allowed"
                                                    >
                                                        <img src="/util/app/b3-admin-export.svg" className="h-5 content-center opacity-20  " /> <span className=" ">Export</span>
                                                    </button>
                                                </div>
                                                <div className="animate-shimmer bg-gradient-to-r from-[#121216] via-[#1e1e25] to-[#121216] bg-[length:200%_100%]  text-zinc-700 py-2.5 px-3 rounded-lg text-sm flex items-center gap-2 cursor-not-allowed">
                                                    Ask Anything
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                )}

                {(storypathType === 'generate' || storypathType === 'competition')

                    && (

                        <>


                            {/* <div className='w-full p-4'>
                                <DeepSearch />
                            </div> */}



                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                className={`${user?.email === 'john.brunswick@gmail.com' ? '' : ' '}`}
                                transition={{
                                    duration: 0.25,
                                    ease: "easeOut"
                                }}
                            >
                                <div className='flex mt-12' >

                                    <div className='flex-none print:hidden mt-4 '>
                                        <div className={`justify-center items-center text-sm mr-4 text-center rounded-full h-10 w-10   
                                ${allowGeneration ?
                                                "justify-center items-center text-sm text-zinc-100 font-medium mr-4  text-center  rounded-full  h-10 w-10  pt-2 text-zinc-50 border-sky-600 bg-black/20 border-2 " :
                                                "text-zinc-400 font-medium bg-black/20 pt-2.5"
                                            }`}>
                                            1
                                        </div>
                                        <div className=' w-0.5 h-[calc(100%-40px)] mt-1  bg-white/5 ml-5'>
                                        </div>
                                    </div>




                                    <div className='flex-auto  w-full   '>
                                        <div className='flex-auto flex gap-4'>
                                            <div className='flex-grow'>

                                                {/* <div className="container mx-auto">
                                                        <h1 className="text-2xl font-bold mb-4">Website Crawler Tool</h1>
                                                        <WebCrawlerModal />
                                                    </div> */}

                                                {/* <div>
                                                        <div className={`text-lg font-medium ${allowGeneration ? 'text-sky-400' : 'text-zinc-400'}`}>Create New Scenario</div>
                                                        <div className='w-full text-zinc-400 text-base font-normal'>Please complete the following sentence to get our collaboration started</div>
                                                    </div> */}








                                                <div>
                                                    {/* Tab Navigation 
                                                    UPLOAD WAS HERE... 
                                                    */}
                                                    <div className="flex">
                                                        {['Discover Paths', 'Load Existing Paths'].map((tab, index) => (
                                                            <motion.div
                                                                key={tab}
                                                                className={`px-4 pr-8 py-6 mr-2 rounded-t-lg cursor-pointer text-base font-medium transition-colors flex items-center ${activeScenarioTab === index
                                                                    ? 'bg-black/30 text-sky-400'
                                                                    : 'bg-black/10 text-zinc-400 hover:bg-black/15'
                                                                    }`}
                                                                // onClick={() => setActiveScenarioTab(index)}
                                                                onClick={() => {
                                                                    setActiveScenarioTab(index);
                                                                    if (index === 1 || index === 0) {
                                                                        setCurrentFormStep(4);
                                                                    }
                                                                }}
                                                                whileHover={{ y: -2 }}
                                                                whileTap={{ scale: 0.95 }}
                                                            >
                                                                {index === 0 ? (
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        className="h-7 w-7 mr-2"
                                                                        fill="none"
                                                                        viewBox="0 0 24 24"
                                                                        stroke="currentColor"
                                                                    >
                                                                        <path
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                            strokeWidth={2}
                                                                            d="M12 4v16m8-8H4"
                                                                        />
                                                                    </svg>
                                                                ) : index === 2 ? (
                                                                    <img
                                                                        src="/util/app/b3-admin-materials-upload-3.svg"
                                                                        className="h-7   mr-2 opacity-50 group-hover:opacity-100"
                                                                        alt="Scenarios history"
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        src="/util/app/b3-admin-prompt-history.svg"
                                                                        className="h-7   mr-2 opacity-50 group-hover:opacity-100"
                                                                        alt="Scenarios history"
                                                                    />
                                                                )}
                                                                {tab}
                                                            </motion.div>
                                                        ))}
                                                    </div>

                                                    {/* Tab Content */}

                                                </div>






                                                {/* Recent Prompts Section */}






                                            </div>
                                            {/* <div className='flex-none mr-0 mt-4'>
                                                <CompAIStoryTone
                                                    initialToneSettings={storyTone}
                                                    onToneChange={handleToneChange}
                                                />
                                            </div> */}
                                        </div>
                                        {error && (
                                            <div className="  p-6  text-red-300 rounded bg-black/30">
                                                {error}
                                            </div>
                                        )}


                                        {showChallengesModal && (
                                            <AnimatePresence>
                                                <motion.div
                                                    className="fixed inset-0 z-50 overflow-y-auto flex items-center justify-center"
                                                    aria-labelledby="modal-title"
                                                    role="dialog"
                                                    aria-modal="true"
                                                    initial={{ opacity: 0 }}
                                                    animate={{ opacity: 1 }}
                                                    exit={{ opacity: 0 }}
                                                    transition={{ duration: 0.3 }}
                                                >

                                                    <motion.div
                                                        className="fixed inset-0 bg-black/75 transition-opacity"
                                                        aria-hidden="true"
                                                        onClick={() => setShowChallengesModal(false)}
                                                        initial={{ opacity: 0 }}
                                                        animate={{ opacity: 1 }}
                                                        exit={{ opacity: 0 }}
                                                    ></motion.div>


                                                    <motion.div
                                                        className="relative bg-zinc-900 rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-3/4 h-3/4 max-h-[75vh]"
                                                        initial={{ scale: 0.9, y: 20 }}
                                                        animate={{ scale: 1, y: 0 }}
                                                        exit={{ scale: 0.9, y: 20 }}
                                                        transition={{ type: "spring", bounce: 0.3, duration: 0.5 }}
                                                    >
                                                        <div className="flex justify-between items-center px-6 py-4 ">
                                                            <h3 className="text-2xl mt-4 ml-4 text-zinc-100">Potential Customer Challenges</h3>
                                                            <button
                                                                className="text-zinc-400 hover:text-zinc-200"
                                                                onClick={() => setShowChallengesModal(false)}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                                </svg>
                                                            </button>
                                                        </div>

                                                        <div className="px-6 py-4 h-[calc(100%-8rem)] overflow-y-auto mx-auto w-full">
                                                            {loadingChallenges ? (
                                                                <div className="flex justify-center items-center h-full p-8">
                                                                    <div className="text-zinc-400 flex flex-col items-center">
                                                                        <RotateSpinner color="#38BDF8" className="mx-auto mb-6" size={64} />
                                                                        <div className="text-zinc-300 text-lg mt-12">Thinking about potential customer challenges</div>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className=" grid grid-cols-3 gap-4">
                                                                    {challenges && challenges.length > 0 ?
                                                                        challenges.map((challenge, index) => (
                                                                            <motion.div
                                                                                key={index}
                                                                                className="w-full flex flex-col text-left p-4 bg-black/20 rounded-lg hover:bg-black/30 border border-zinc-800 transition-all duration-200 hover:border-sky-500 cursor-pointer"
                                                                                onClick={() => {
                                                                                    setFormData({
                                                                                        ...formData,
                                                                                        promptCustomerProblem: challenge.title
                                                                                    });
                                                                                    setShowChallengesModal(false);
                                                                                }}
                                                                                whileHover={{
                                                                                    scale: 1.01,
                                                                                    transition: { duration: 0.2 }
                                                                                }}
                                                                            >

                                                                                <h4 className="text-lg text-white mb-2">{challenge.title}</h4>
                                                                                <p className="text-zinc-400 text-sm leading-6 mb-3">{challenge.description}</p>

                                                                                {challenge.impacts && challenge.impacts.length > 0 && (
                                                                                    <div className="mb-3">
                                                                                        <div className="text-xs text-sky-400 mt-4 mb-2 ml-2">Helps Solve</div>
                                                                                        <div className="flex flex-wrap gap-1 mt-4">
                                                                                            {challenge.impacts.map((impact, i) => (
                                                                                                <span key={i} className="text-xs bg-sky-400/5 px-2 py-1 rounded-full text-sky-300">
                                                                                                    {impact}
                                                                                                </span>
                                                                                            ))}
                                                                                        </div>
                                                                                    </div>
                                                                                )}

                                                                            </motion.div>
                                                                        )) : (
                                                                            <div className="text-zinc-400 text-sm p-6 text-center col-span-3">
                                                                                No challenges found. Try with different product or customer information.
                                                                            </div>
                                                                        )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </motion.div>
                                                </motion.div>
                                            </AnimatePresence>
                                        )}


                                        {/* <CompExplainer
                                            user={user}
                                            title="Using The Story Prompt"
                                            explainerId="story-prompt-tips"
                                            type="inline"
                                            className="mx-0"
                                        >
                                            <div className='text-zinc-100 text-sm'>
                                                This kicks off your research! Enter the company, contact, and problems you think they might be struggling to solve, and boom—StoryPath generates insights to make you sound like you've been following their business for years. Walking into a meeting blind is like showing up to a first date without looking at their profile—bad move. Don't just skim—look for patterns. If you don't know what problem they're trying to solve, assume they don't either.

                                                <div className='mt-8 text-amber-200 text-sm'>
                                                    Please note that the first research segment may take a minute to complete.  In our next release, this time will be reduced by 50%.  We appreciate your patience!-
                                                </div>
                                            </div>
                                        </CompExplainer> */}

                                        <div id="form-joyride-target" className='w-full p-8 mx-auto  bg-black/30 rounded-b-lg rounded-tr-lg mb-8'>
                                            {activeScenarioTab === 1 ? (
                                                <AnimatePresence mode="wait">
                                                    <motion.div
                                                        key={activeScenarioTab}
                                                        initial={{ opacity: 0, }}
                                                        animate={{ opacity: 1, x: 0 }}
                                                        exit={{ opacity: 0, }}
                                                        transition={{ duration: 0.3 }}
                                                        className="w-full"
                                                    >
                                                        {activeScenarioTab === 0 ? (
                                                            <></>) : (
                                                            <div className='w-full mb-8'>

                                                                {recentPrompts.length < 1 && (
                                                                    <div className="mt-2 mb-2 animate__animated animate__fadeIn text-zinc-50">
                                                                        Once you create a new path, it will appear here to allow you to select it, modify it and re-run it.
                                                                    </div>
                                                                )}
                                                                {recentPrompts.length > 0 && (
                                                                    <div className="mt-2 mb-2 animate__animated animate__fadeIn">
                                                                        <div className=" mb-2">
                                                                            <div className="text-zinc-200 text-lg mb-6 ml-3">1. Select Existing Path</div>
                                                                            <div className="w-full gap-4 grid grid-cols-5">
                                                                                {/* <img src="/util/app/b3-admin-prompt-history.svg" className="h-8 self-center opacity-50 group-hover:opacity-100" /> */}

                                                                                {recentPrompts.map((prompt, index) => (
                                                                                    <motion.div
                                                                                        key={prompt.id + prompt.promptCustomerName}
                                                                                        className="bg-black/20 text-zinc-200 rounded-lg p-3 text-sm cursor-pointer hover:bg-black/50 transition-colors flex justify-between items-center"
                                                                                        onClick={() => handlePromptClick(prompt)}
                                                                                        whileTap={{ scale: 0.95 }}
                                                                                        whileHover={{ scale: 1.01 }}
                                                                                        initial={{ opacity: 0, y: 20 }}
                                                                                        animate={{ opacity: 1, y: 0 }}
                                                                                        transition={{
                                                                                            duration: 0.2,
                                                                                            ease: "easeOut",
                                                                                            layout: { duration: 0.2 }
                                                                                        }}
                                                                                    >
                                                                                        <div className="group">
                                                                                            <div className="pl-1.5">
                                                                                                {prompt.promptCustomerName || 'Unnamed Customer'} - {prompt.promptProductName || 'Unnamed Product'}

                                                                                                {/* <p><span className="font-semibold">Company:</span> {prompt.promptCompanyName || 'N/A'}</p> */}
                                                                                                <p className='text-sm mt-1'> {prompt.promptCustomerRole || 'N/A'}</p>
                                                                                                <p className='text-sm mt-3'> {prompt.promptCustomerProblem || 'N/A'}</p>
                                                                                                <p className='text-xs text-sky-400 mt-3'>load path</p>
                                                                                            </div>

                                                                                        </div>

                                                                                        <button
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                handleDeletePrompt(prompt.id);
                                                                                            }}
                                                                                            className="absolute top-2 right-2 text-zinc-400 hover:text-red-400 transition-colors"
                                                                                        >
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                                                                                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                                                                            </svg>
                                                                                        </button>
                                                                                    </motion.div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </motion.div>
                                                </AnimatePresence>
                                            ) : (
                                                <>
                                                </>
                                            )}


                                            {activeScenarioTab === 0 ? (
                                                <div className="w-full   mx-auto hidden">

                                                    {/* Progress Indicator */}
                                                    <div className="flex items-center justify-between mb-8">
                                                        <div
                                                            className={`font-normal ${currentFormStep >= 1 ? 'text-zinc-100' : 'text-zinc-500'} cursor-pointer`}
                                                            onClick={() => setCurrentFormStep(1)}
                                                        >
                                                            <div className='flex items-center'>
                                                                <motion.div
                                                                    className='w-10 h-10 bg-zinc-800 rounded-full flex items-center justify-center'
                                                                    animate={currentFormStep === 1 ? {
                                                                        scale: [1, 1.2, 1],
                                                                    } : {}}
                                                                    transition={currentFormStep === 1 ? {
                                                                        duration: 0.5,
                                                                        ease: "easeInOut",
                                                                        times: [0, 0.5, 1]
                                                                    } : {}}
                                                                >1</motion.div>
                                                                <div className='ml-2'>What You Sell</div>
                                                            </div>
                                                        </div>

                                                        <div className="flex-1 h-0.5 mx-2 bg-gray-700">
                                                            <div
                                                                className="h-0.5 bg-sky-500 transition-all duration-300"
                                                                style={{ width: currentFormStep >= 2 ? '100%' : '0%' }}
                                                            ></div>
                                                        </div>

                                                        <div
                                                            className={`font-normal ${currentFormStep >= 2 ? 'text-zinc-100' : 'text-zinc-500'} cursor-pointer`}
                                                            onClick={() => setCurrentFormStep(2)}
                                                        >
                                                            <div className='flex items-center'>
                                                                <motion.div
                                                                    className='w-10 h-10 bg-zinc-800 rounded-full flex items-center justify-center'
                                                                    animate={currentFormStep === 2 ? {
                                                                        scale: [1, 1.2, 1],
                                                                    } : {}}
                                                                    transition={currentFormStep === 2 ? {
                                                                        duration: 0.5,
                                                                        ease: "easeInOut",
                                                                        times: [0, 0.5, 1]
                                                                    } : {}}
                                                                >2</motion.div>
                                                                <div className='ml-2'>Who You Sell To</div>
                                                            </div>
                                                        </div>

                                                        <div className="flex-1 h-0.5 mx-2 bg-gray-700">
                                                            <div
                                                                className="h-0.5 bg-sky-500 transition-all duration-300"
                                                                style={{ width: currentFormStep >= 3 ? '100%' : '0%' }}
                                                            ></div>
                                                        </div>

                                                        <div
                                                            className={`font-normal ${currentFormStep >= 3 ? 'text-zinc-100' : 'text-zinc-500'} cursor-pointer`}
                                                            onClick={() => setCurrentFormStep(3)}
                                                        >
                                                            <div className='flex items-center'>
                                                                <motion.div
                                                                    className='w-10 h-10 bg-zinc-800 rounded-full flex items-center justify-center'
                                                                    animate={currentFormStep === 3 ? {
                                                                        scale: [1, 1.2, 1],
                                                                    } : {}}
                                                                    transition={currentFormStep === 3 ? {
                                                                        duration: 0.5,
                                                                        ease: "easeInOut",
                                                                        times: [0, 0.5, 1]
                                                                    } : {}}
                                                                >3</motion.div>
                                                                <div className='ml-2'>Problem You Solve</div>
                                                            </div>
                                                        </div>

                                                        <div className="flex-1 h-0.5 mx-2 bg-gray-700">
                                                            <div
                                                                className="h-0.5 bg-sky-500 transition-all duration-300"
                                                                style={{ width: currentFormStep >= 4 ? '100%' : '0%' }}
                                                            ></div>
                                                        </div>

                                                        <div
                                                            className={`font-normal ${currentFormStep >= 4 ? 'text-zinc-100' : 'text-zinc-500'} cursor-pointer`}
                                                            onClick={() => setCurrentFormStep(4)}
                                                        >
                                                            <div className='flex items-center'>
                                                                <motion.div
                                                                    className='w-10 h-10 bg-zinc-800 rounded-full flex items-center justify-center'
                                                                    animate={currentFormStep === 4 ? {
                                                                        scale: [1, 1.2, 1],
                                                                    } : {}}
                                                                    transition={currentFormStep === 4 ? {
                                                                        duration: 0.5,
                                                                        ease: "easeInOut",
                                                                        times: [0, 0.5, 1]
                                                                    } : {}}
                                                                >4</motion.div>
                                                                <div className='ml-2'>Review and Generate</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                </>
                                            )}


                                            {activeScenarioTab === 2 && (
                                                <div className="w-full   mx-auto ">
                                                    <div className="flex flex-col md:flex-row gap-6">
                                                        {/* Left side - Upload interface */}
                                                        <div className="w-full md:w-2/5   rounded-lg p-4">
                                                            <h3 className="text-lg font-normal text-zinc-100 -mt-4 mb-4">Upload Document</h3>
                                                            <div className="border-2 border-dashed border-zinc-700 rounded-lg p-6 text-center hover:border-sky-500 transition-colors">
                                                                <input
                                                                    type="file"
                                                                    id="document-upload"
                                                                    className="hidden"
                                                                    onChange={handleFileUpload}
                                                                />
                                                                <label
                                                                    htmlFor="document-upload"
                                                                    className="cursor-pointer flex flex-col items-center justify-center"
                                                                >
                                                                    <img src="/util/app/b3-admin-materials-upload-3.svg" className="h-12 mb-4" />
                                                                    <span className="text-zinc-300 text-sm font-medium">Click to upload or drag and drop</span>
                                                                    <span className="text-zinc-500 text-xs mt-1">PDF, DOCX, TXT, etc.</span>
                                                                </label>
                                                            </div>

                                                            {uploadStatus && (
                                                                <div className="mt-4">
                                                                    {uploadStatus === 'uploading' && (
                                                                        <div className="flex items-center justify-center space-x-2">
                                                                            <ImpulseSpinner size={30} frontColor="#0EA5E9" backColor="#1E293B" />
                                                                            <span className="text-zinc-300">Processing document...</span>
                                                                        </div>
                                                                    )}
                                                                    {uploadStatus === 'success' && (
                                                                        <div className="bg-green-500/20 border border-green-500/30 text-green-400 p-3 rounded-md">
                                                                            Document uploaded successfully!
                                                                        </div>
                                                                    )}
                                                                    {uploadStatus === 'error' && (
                                                                        <div className="bg-red-500/20 border border-red-500/30 text-red-400 p-3 rounded-md">
                                                                            Error uploading document. Please try again.
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Right side - Document list */}
                                                        <div className="w-full md:w-3/5  rounded-lg p-4">
                                                            <h3 className="text-lg font-normal text-zinc-100 mb-4 -mt-4">Your Documents</h3>



                                                            {isViewModalOpen && viewingDocument && (
                                                                <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
                                                                    <div className="bg-zinc-900 rounded-lg w-3/4 max-h-[90vh] overflow-hidden flex flex-col">
                                                                        <div className="flex items-center justify-between border-b border-zinc-800 p-4">
                                                                            <h3 className="text-lg font-medium text-zinc-100">
                                                                                {viewingDocument.name || "Document"}
                                                                            </h3>
                                                                            <button
                                                                                onClick={() => setIsViewModalOpen(false)}
                                                                                className="p-1.5 bg-zinc-800 text-zinc-400 rounded-full hover:bg-zinc-700 transition-colors"
                                                                            >
                                                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                                                </svg>
                                                                            </button>
                                                                        </div>

                                                                        <div className="p-4 overflow-y-auto flex-1">
                                                                            {viewingDocument.data ? (
                                                                                <div className="prose prose-invert max-w-none">
                                                                                    <Markdown>{typeof viewingDocument.data === 'string'
                                                                                        ? JSON.parse(viewingDocument.data)?.markdown || viewingDocument.data
                                                                                        : viewingDocument.data?.markdown || viewingDocument.data}</Markdown>
                                                                                </div>
                                                                            ) : (
                                                                                <div className="flex flex-col items-center justify-center py-12 text-zinc-500">
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                                                    </svg>
                                                                                    <p>No content available for this document</p>
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                        <div className="border-t border-zinc-800 p-4 flex justify-end">
                                                                            <button
                                                                                onClick={() => setIsViewModalOpen(false)}
                                                                                className="px-4 py-2 bg-sky-500 hover:bg-sky-400 text-white rounded-md transition-colors"
                                                                            >
                                                                                Close
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {learningDocuments.length === 0 ? (
                                                                <div className="text-center py-8 text-zinc-500">
                                                                    No documents uploaded yet
                                                                </div>
                                                            ) : (
                                                                <div className="space-y-3 max-h-[400px] overflow-y-auto pr-2">
                                                                    {learningDocuments.map((doc, index) => (
                                                                        <div key={index} className="flex items-center justify-between bg-zinc-800/50 p-3 rounded-md">
                                                                            <div className="flex items-center">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-sky-400 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                                                </svg>
                                                                                <span className="text-zinc-300 truncate max-w-[180px]">{doc.name || `Document ${index + 1}`}</span>
                                                                            </div>
                                                                            <div className="flex space-x-2">
                                                                                <button
                                                                                    onClick={() => handleViewDocument(doc)}
                                                                                    className="p-1.5 bg-sky-500/20 text-sky-400 rounded hover:bg-sky-500/30 transition-colors"
                                                                                >
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                                                    </svg>
                                                                                </button>
                                                                                <button
                                                                                    onClick={() => handleDeleteDocument(doc.id)}
                                                                                    className="p-1.5 bg-red-500/20 text-red-400 rounded hover:bg-red-500/30 transition-colors"
                                                                                >
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                                                    </svg>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Document View Modal */}
                                                    {selectedDocument && (
                                                        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
                                                            <div className="bg-zinc-900 rounded-lg w-full max-w-4xl max-h-[80vh] overflow-hidden flex flex-col">
                                                                <div className="flex items-center justify-between p-4 border-b border-zinc-800">
                                                                    <h3 className="text-lg font-medium text-zinc-100">
                                                                        {selectedDocument.name || 'Document Details'}
                                                                    </h3>
                                                                    <button
                                                                        onClick={() => setSelectedDocument(null)}
                                                                        className="text-zinc-400 hover:text-zinc-100"
                                                                    >
                                                                        <XMarkIcon className="h-6 w-6" />
                                                                    </button>
                                                                </div>
                                                                <div className="p-6 overflow-y-auto flex-grow">
                                                                    <div className="prose prose-invert max-w-none">
                                                                        {selectedDocument.markdown ? (
                                                                            <div dangerouslySetInnerHTML={{ __html: marked(selectedDocument.markdown) }} />
                                                                        ) : (
                                                                            <div className="text-zinc-400">No content available</div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}


                                            {activeScenarioTab === 0 || activeScenarioTab === 1 ? (
                                                <form onSubmit={(e) => e.preventDefault()}>
                                                    <AnimatePresence mode="wait">
                                                        {currentFormStep === 1 && (
                                                            <motion.div
                                                                key="step1"
                                                                initial={{ opacity: 0 }}
                                                                animate={{ opacity: 1 }}
                                                                exit={{ opacity: 0 }}
                                                                transition={{ duration: 0.3 }}
                                                                className="space-y-6"
                                                            >
                                                                <div className="grid grid-cols-1 md:grid-cols-12 gap-6 ">
                                                                    <div className="md:col-span-10 space-y-4">
                                                                        <div>
                                                                            <label className="block text-zinc-400 mb-1 ml-3 text-sm"> Company Name</label>
                                                                            <input
                                                                                type="text"
                                                                                name="promptCompanyName"
                                                                                value={formData.promptCompanyName}
                                                                                placeholder="Company Name"
                                                                                onChange={handleInputChange}
                                                                                className={`w-full p-3 bg-black/20 text-zinc-50 rounded-md border transition-colors duration-200 ${touchedFields.promptCompanyName && !formData.promptCompanyName && isFormSubmitted
                                                                                    ? 'border-red-400/50 bg-red-400/10 focus:border-red-400/50'
                                                                                    : 'border-zinc-700 focus:border-sky-500'
                                                                                    } focus:ring-1 ${touchedFields.promptCompanyName && !formData.promptCompanyName && isFormSubmitted
                                                                                        ? 'focus:ring-red-400/50'
                                                                                        : 'focus:ring-sky-500'
                                                                                    }`}
                                                                                onBlur={handleFieldBlur}
                                                                            />
                                                                            {touchedFields.promptCompanyName && !formData.promptCompanyName && isFormSubmitted ? (
                                                                                <p className="text-red-400 text-sm mt-1 ml-3">Please enter your company name</p>
                                                                            ) : (
                                                                                <p className="text-zinc-400 text-sm mt-1 ml-3">Where you work</p>
                                                                            )}
                                                                        </div>

                                                                        <div>
                                                                            <label className="block text-zinc-400 mb-1 ml-3 text-sm">Product Name(s)</label>
                                                                            <input
                                                                                type="text"
                                                                                name="promptProductName"
                                                                                value={formData.promptProductName}
                                                                                placeholder="Product Name"
                                                                                onChange={handleInputChange}
                                                                                className={`w-full p-3 bg-black/20 text-zinc-50 rounded-md border transition-colors duration-200 ${touchedFields.promptProductName && !formData.promptProductName && isFormSubmitted
                                                                                    ? 'border-red-400/50 bg-red-400/10 focus:border-red-400/50'
                                                                                    : 'border-zinc-700 focus:border-sky-500'
                                                                                    } focus:ring-1 ${touchedFields.promptProductName && !formData.promptProductName && isFormSubmitted
                                                                                        ? 'focus:ring-red-400/50'
                                                                                        : 'focus:ring-sky-500'
                                                                                    }`}
                                                                                onBlur={handleFieldBlur}
                                                                            />
                                                                            {touchedFields.promptProductName && !formData.promptProductName && isFormSubmitted && (
                                                                                <p className="text-red-400 text-sm mt-1 ml-3">Please enter your product name</p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <GuidancePanel title="How to Use">
                                                                        <ul className="space-y-2 text-sm text-zinc-300">
                                                                            <li className="flex items-start">
                                                                                <span className="text-sky-400 mr-2">•</span>
                                                                                <span>Enter your company name as used in your company materials</span>
                                                                            </li>
                                                                            <li className="flex items-start">
                                                                                <span className="text-sky-400 mr-2">•</span>
                                                                                <span>Use product names as they appear in company materials</span>
                                                                            </li>
                                                                            <li className="flex items-start">
                                                                                <span className="text-sky-400 mr-2">•</span>
                                                                                <span>Include more than one products by separating each with a comma</span>
                                                                            </li>
                                                                        </ul>
                                                                    </GuidancePanel>
                                                                </div>
                                                            </motion.div>
                                                        )}

                                                        {currentFormStep === 2 && (
                                                            <motion.div
                                                                key="step2"
                                                                initial={{ opacity: 0 }}
                                                                animate={{ opacity: 1 }}
                                                                exit={{ opacity: 0 }}
                                                                transition={{ duration: 0.3 }}
                                                                className="space-y-6"
                                                            >
                                                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                                                    <div className="md:col-span-2 space-y-4">
                                                                        <div className=''>
                                                                            <label className="block text-zinc-400 mb-1 ml-3 text-sm">Target Role</label>
                                                                            <input
                                                                                type="text"
                                                                                name="promptCustomerRole"
                                                                                placeholder="Target Role (e.g., CTO, Marketing Director)"
                                                                                value={formData.promptCustomerRole}
                                                                                onChange={handleInputChange}
                                                                                className={`w-full p-3 bg-black/20 text-zinc-50 rounded-md border transition-colors duration-200 ${touchedFields.promptCustomerRole && !formData.promptCustomerRole && isFormSubmitted
                                                                                    ? 'border-red-400/50 bg-red-400/10 focus:border-red-400/50'
                                                                                    : 'border-zinc-700 focus:border-sky-500'
                                                                                    } focus:ring-1 ${touchedFields.promptCustomerRole && !formData.promptCustomerRole && isFormSubmitted
                                                                                        ? 'focus:ring-red-400/50'
                                                                                        : 'focus:ring-sky-500'
                                                                                    }`}
                                                                                onBlur={handleFieldBlur}
                                                                            />
                                                                            {touchedFields.promptCustomerRole && !formData.promptCustomerRole && isFormSubmitted && (
                                                                                <p className="text-red-400 text-sm mt-1 ml-3">Please enter the target role</p>
                                                                            )}
                                                                        </div>

                                                                        <div>
                                                                            <label className="block text-zinc-400 mb-1 ml-3 text-sm">Prospect Company</label>
                                                                            <input
                                                                                type="text"
                                                                                name="promptCustomerName"
                                                                                placeholder="Prospect Company Name"
                                                                                value={formData.promptCustomerName}
                                                                                onChange={handleInputChange}
                                                                                className={`w-full p-3 bg-black/20 text-zinc-50 rounded-md border transition-colors duration-200 ${touchedFields.promptCustomerName && !formData.promptCustomerName && isFormSubmitted
                                                                                    ? 'border-red-400/50 bg-red-400/10 focus:border-red-400/50'
                                                                                    : 'border-zinc-700 focus:border-sky-500'
                                                                                    } focus:ring-1 ${touchedFields.promptCustomerName && !formData.promptCustomerName && isFormSubmitted
                                                                                        ? 'focus:ring-red-400/50'
                                                                                        : 'focus:ring-sky-500'
                                                                                    }`}
                                                                                onBlur={handleFieldBlur}
                                                                            />
                                                                            {touchedFields.promptCustomerName && !formData.promptCustomerName && isFormSubmitted && (
                                                                                <p className="text-red-400 text-sm mt-1 ml-3">Please enter the prospect company name</p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <GuidancePanel title="How to Use">
                                                                        <ul className="space-y-2 text-sm text-zinc-300">
                                                                            <li className="flex items-start">
                                                                                <span className="text-sky-400 mr-2">•</span>
                                                                                <span>Target role should be a specific job title</span>
                                                                            </li>
                                                                            <li className="flex items-start">
                                                                                <span className="text-sky-400 mr-2">•</span>
                                                                                <span>Use the company name as it appears in your CRM</span>
                                                                            </li>
                                                                            <li className="flex items-start">
                                                                                <span className="text-sky-400 mr-2">•</span>
                                                                                <span>This information will be used to personalize your AI-generated story</span>
                                                                            </li>
                                                                        </ul>
                                                                    </GuidancePanel>
                                                                </div>
                                                            </motion.div>
                                                        )}

                                                        {currentFormStep === 3 && (
                                                            <motion.div
                                                                key="step3"
                                                                initial={{ opacity: 0 }}
                                                                animate={{ opacity: 1 }}
                                                                exit={{ opacity: 0 }}
                                                                transition={{ duration: 0.3 }}
                                                                className="space-y-6"
                                                            >
                                                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                                                    <div className="md:col-span-2 space-y-4">
                                                                        <div>
                                                                            <label className="block text-zinc-400 mb-1 ml-3 text-sm">Customer Problem</label>
                                                                            <textarea
                                                                                name="promptCustomerProblem"
                                                                                value={formData.promptCustomerProblem}
                                                                                onChange={handleInputChange}
                                                                                placeholder="Describe the problem your customer is facing..."
                                                                                className={`w-full p-3 bg-black/20 text-zinc-50 rounded-md border min-h-[120px] transition-colors duration-200 ${touchedFields.promptCustomerProblem && !formData.promptCustomerProblem && isFormSubmitted
                                                                                    ? 'border-red-400/50 bg-red-400/10 focus:border-red-400/50'
                                                                                    : 'border-zinc-700 focus:border-sky-500'
                                                                                    } focus:ring-1 ${touchedFields.promptCustomerProblem && !formData.promptCustomerProblem && isFormSubmitted
                                                                                        ? 'focus:ring-red-400/50'
                                                                                        : 'focus:ring-sky-500'
                                                                                    }`}
                                                                                rows="4"
                                                                                required
                                                                                onBlur={handleFieldBlur}
                                                                            />
                                                                            {touchedFields.promptCustomerProblem && !formData.promptCustomerProblem && isFormSubmitted && (
                                                                                <p className="text-red-400 text-sm mt-1 ml-3">Please describe the problem to overcome</p>
                                                                            )}
                                                                        </div>

                                                                    </div>
                                                                    <GuidancePanel title="How to Use">
                                                                        <div className='grid grid-cols-6 gap-4  '>
                                                                            <ul className="space-y-2 col-span-5 text-sm text-zinc-300 ">
                                                                                <li className="flex items-start">
                                                                                    <span className="text-sky-400 mr-2">•</span>
                                                                                    <span>Be specific about the problem your customer is facing</span>
                                                                                </li>
                                                                                <li className="flex items-start">
                                                                                    <span className="text-sky-400 mr-2">•</span>
                                                                                    <span>If you need ideas, click the stars <span className="text-orange-300 text-xs">* design partner testing</span></span>
                                                                                </li>
                                                                            </ul>
                                                                            <div className='col-span-1'>
                                                                                <motion.button
                                                                                    className="p-2.5 hover:bg-zinc-700 bg-zinc-800 rounded-md"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        const requiredFieldsForBrainstorm = [
                                                                                            'promptCompanyName',
                                                                                            'promptProductName',
                                                                                            'promptCustomerRole',
                                                                                            'promptCustomerName'
                                                                                        ];
                                                                                        const emptyFields = requiredFieldsForBrainstorm.filter(field => !formData[field]);

                                                                                        if (emptyFields.length > 0) {
                                                                                            setIgnoreProblemValidationForBrainstorm(true);
                                                                                            setIsFormSubmitted(true);
                                                                                            const firstEmptyField = document.querySelector(`[name="${emptyFields[0]}"]`);
                                                                                            if (firstEmptyField) {
                                                                                                firstEmptyField.focus();
                                                                                            }
                                                                                            setError("Please fill out Your Company, Your Product, Target Role, and Target Company before brainstorming.");
                                                                                            setTimeout(() => {
                                                                                                setIgnoreProblemValidationForBrainstorm(false);
                                                                                            }, 50);
                                                                                            return;
                                                                                        }
                                                                                        setIgnoreProblemValidationForBrainstorm(false);
                                                                                        setError(null); // Clear any previous errors
                                                                                        findCustomerChallenges();
                                                                                        setShowChallengesModal(true);
                                                                                    }}
                                                                                    whileHover={{ scale: 1.01 }}
                                                                                    whileTap={{ scale: 0.95 }}
                                                                                    transition={{ duration: 0.2 }}
                                                                                >
                                                                                    <svg className="w-8 h-8 text-sky-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ transform: 'scale(1)', color: 'rgb(56, 189, 248)' }}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"></path></svg>
                                                                                </motion.button>
                                                                            </div>
                                                                        </div>
                                                                    </GuidancePanel>
                                                                </div>
                                                            </motion.div>
                                                        )}

                                                        {currentFormStep === 4 && (
                                                            <motion.div
                                                                key="step4"
                                                                initial={{ opacity: 0 }}
                                                                animate={{ opacity: 1 }}
                                                                exit={{ opacity: 0 }}
                                                                transition={{ duration: 0.3 }}
                                                                className="space-y-6"
                                                            >
                                                                <div className="flex flex-col md:flex-row gap-6">
                                                                    <div className="flex-grow space-y-4">
                                                                        <div className='flex-grow '>
                                                                            {/* <div className='text-zinc-400 text-sm ml-3 mb-6 '>
                                                                    Please review the information below and click the button below to generate insights
                                                                </div> */}

                                                                            {activeScenarioTab == 0 ? (
                                                                                <p className="text-zinc-200 text-lg mb-8 mt-1  ml-2">1. Complete the sentence below to discover paths </p>
                                                                            ) : (

                                                                                <p className="text-zinc-200 text-lg mb-8 mt-1  ml-2">2. Complete the sentence below to discover paths </p>
                                                                            )}


                                                                            <div className="flex flex-wrap items-center gap-2 gap-y-4 text-zinc-300">
                                                                                <div className="flex-grow group"> {/* Add group class here */}
                                                                                    <input
                                                                                        type="text"
                                                                                        name="promptCompanyName"
                                                                                        value={formData.promptCompanyName}
                                                                                        placeholder="Your Company"
                                                                                        onChange={handleInputChange}
                                                                                        className={`inline-flex w-full p-3 bg-black/20 text-zinc-50 rounded-md border transition-colors duration-200 ${formData.promptCompanyName || !isFormSubmitted ? 'border-zinc-700 focus:border-sky-500' : 'border-red-400/50 bg-red-400/10 focus:border-red-400/50'} focus:ring-1 ${formData.promptCompanyName || !isFormSubmitted ? 'focus:ring-sky-500' : 'focus:ring-red-400/50'} `}
                                                                                        onBlur={handleFieldBlur}
                                                                                    //required
                                                                                    />
                                                                                    {!formData.promptCompanyName && isFormSubmitted ? (
                                                                                        <p className="text-red-400 text-sm mt-1 ml-3">Please enter your company name</p>
                                                                                    ) : (
                                                                                        <p className="text-zinc-400 text-sm mt-1 ml-3 opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity duration-200">Where you work</p>)}
                                                                                </div>
                                                                                <div className="px-3 -mt-6">would like to sell </div>
                                                                                <div className="flex-grow w-1/3 group"> {/* Add group class here */}
                                                                                    <input
                                                                                        type="text"
                                                                                        name="promptProductName"
                                                                                        value={formData.promptProductName}
                                                                                        placeholder="Your Product(s)"
                                                                                        onChange={handleInputChange}
                                                                                        className={`inline-flex w-full p-3 bg-black/20 text-zinc-50 rounded-md border transition-colors duration-200 ${formData.promptProductName || !isFormSubmitted ? 'border-zinc-700 focus:border-sky-500' : 'border-red-400/50 bg-red-400/10 focus:border-red-400/50'} focus:ring-1 ${formData.promptProductName || !isFormSubmitted ? 'focus:ring-sky-500' : 'focus:ring-red-400/50'}  `}
                                                                                        onBlur={handleFieldBlur}
                                                                                    // REMOVE onFocus, onMouseEnter, onMouseLeave
                                                                                    />
                                                                                    {!formData.promptProductName && isFormSubmitted ? (
                                                                                        <p className="text-red-400 text-sm mt-1 ml-3">Please enter your product name</p>
                                                                                    ) : (
                                                                                        // Modify paragraph classes for CSS hover/focus
                                                                                        <p className="text-zinc-400 text-sm mt-1 ml-3 opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity duration-200">Cloud Name, Product Name, etc</p>
                                                                                    )}
                                                                                </div>
                                                                                <div className="px-3 -mt-6">to the</div>
                                                                                <div className="flex-grow group"> {/* Add group class here */}
                                                                                    <input
                                                                                        type="text"
                                                                                        name="promptCustomerRole"
                                                                                        placeholder="Target Role"
                                                                                        value={formData.promptCustomerRole}
                                                                                        onChange={handleInputChange}
                                                                                        className={`inline-flex w-full p-3 bg-black/20 text-zinc-50 rounded-md border transition-colors duration-200 ${formData.promptCustomerRole || !isFormSubmitted ? 'border-zinc-700 focus:border-sky-500' : 'border-red-400/50 bg-red-400/10 focus:border-red-400/50'
                                                                                            } focus:ring-1 ${formData.promptCustomerRole || !isFormSubmitted ? 'focus:ring-sky-500' : 'focus:ring-red-400/50'} [&:-webkit-autofill]:bg-zinc-600/25 [&:-webkit-autofill]:!text-zinc-50 [&:-webkit-autofill]:shadow-[0_0_0_30px_rgb(82_82_91_/_0.25)_inset] [&:-webkit-autofill]:[filter:none]`}
                                                                                        onBlur={handleFieldBlur}

                                                                                    />
                                                                                    {!formData.promptCustomerRole && isFormSubmitted ? (
                                                                                        <p className="text-red-400 text-sm mt-1 ml-3">Please enter the target role</p>
                                                                                    ) : (
                                                                                        <p className="text-zinc-400 text-sm mt-1 ml-3 opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity duration-200">VP Engineering, Marketing Director, etc</p>)}
                                                                                </div>
                                                                                <div className="px-3 flex-shrink-0 -mt-6">at</div>
                                                                                {/* Target Company input removed from here */}
                                                                            </div>
                                                                            {/* New row for Target Company, "in order to", Customer Problem, and Suggestions */}
                                                                            <div className="flex items-start gap-x-2 mt-4 text-zinc-300">
                                                                                {/* Part 1: Target Company (1/4 width) */}
                                                                                <div className="w-1/4 group">
                                                                                                                                                                            <input
                                                                                            type="text"
                                                                                            name="promptCustomerName"
                                                                                            placeholder="Target Company"
                                                                                            value={formData.promptCustomerName}
                                                                                            onChange={handleInputChange}
                                                                                            className={`inline-flex w-full p-3 bg-black/20 text-zinc-50 rounded-md border transition-colors duration-200 ${formData.promptCustomerName || !isFormSubmitted ? 'border-zinc-700 focus:border-sky-500' : 'border-red-400/50 bg-red-400/10 focus:border-red-400/50'} focus:ring-1 ${formData.promptCustomerName || !isFormSubmitted ? 'focus:ring-sky-500' : 'focus:ring-red-400/50'} [&:-webkit-autofill]:bg-zinc-600/25 [&:-webkit-autofill]:!text-zinc-50 [&:-webkit-autofill]:shadow-[0_0_0_30px_rgb(82_82_91_/_0.25)_inset] [&:-webkit-autofill]:[filter:none]`}
                                                                                            onBlur={handleFieldBlur}
                                                                                        />
                                                                                    {!formData.promptCustomerName && isFormSubmitted ? (
                                                                                        <p className="text-red-400 text-sm mt-1 ml-3">Please enter the prospect company name</p>
                                                                                    ) : (
                                                                                        <p className="text-zinc-400 text-sm mt-1 ml-3 opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity duration-200">The company you are selling to</p>
                                                                                    )}
                                                                                </div>

                                                                                {/* Part 2: "in order to" text */}
                                                                                <div className="pt-3 px-1 whitespace-nowrap">in order to</div>

                                                                                {/* Part 3: Customer Problem or Goal + opportunity suggestions (fills remaining space) */}
                                                                                <div className="flex-grow flex items-start gap-x-2">
                                                                                    <div className="relative flex-grow group">
                                                                                                                                                                                    <input
                                                                                                name="promptCustomerProblem"
                                                                                                value={formData.promptCustomerProblem}
                                                                                                onChange={handleInputChange}
                                                                                                placeholder="Customer Problem or Goal"
                                                                                                className={`inline-flex w-full p-3 pr-40 bg-black/20 text-zinc-50 rounded-md border transition-colors duration-200 ${!displayProblemError ? 'border-zinc-700 focus:border-sky-500' : 'border-red-400/50 bg-red-400/10 focus:border-red-400/50'} focus:ring-1 ${!displayProblemError ? 'focus:ring-sky-500' : 'focus:ring-red-400/50'} [&:-webkit-autofill]:bg-zinc-600/25 [&:-webkit-autofill]:!text-zinc-50 [&:-webkit-autofill]:shadow-[0_0_0_30px_rgb(82_82_91_/_0.25)_inset] [&:-webkit-autofill]:[filter:none]`}
                                                                                                required
                                                                                                onBlur={handleFieldBlur}
                                                                                            />
                                                                                        <motion.button
                                                                                            className="absolute inset-y-0 right-0 flex pl-5 items-center px-3 text-zinc-400  bg-zinc-800/50   hover:bg-zinc-300/10 hover:text-white text-sm transition-colors h-9 mt-1.5 mr-1.5  rounded-md "
                                                                                            onClick={(e) => {
                                                                                                e.preventDefault();
                                                                                                const requiredFields = [
                                                                                                    'promptCompanyName',
                                                                                                    'promptProductName',
                                                                                                    'promptCustomerRole',
                                                                                                    'promptCustomerName'
                                                                                                ];
                                                                                                const emptyFields = requiredFields.filter(field => !formData[field]);

                                                                                                if (emptyFields.length > 0) {
                                                                                                    setIsFormSubmitted(true);
                                                                                                    // Highlight the first empty field by focusing it.
                                                                                                    const firstEmptyField = document.querySelector(`[name="${emptyFields[0]}"]`);
                                                                                                    if (firstEmptyField) {
                                                                                                        firstEmptyField.focus();
                                                                                                    }
                                                                                                    // Optionally, set a general error message or rely on individual field messages
                                                                                                    setError("Please fill out all required fields before brainstorming.");
                                                                                                    return;
                                                                                                }
                                                                                                setError(null); // Clear any previous errors
                                                                                                findCustomerChallenges();
                                                                                                setShowChallengesModal(true);
                                                                                            }}
                                                                                            whileHover={{ scale: 1.01 }}
                                                                                            whileTap={{ scale: 0.95 }}
                                                                                            transition={{ duration: 0.2 }}
                                                                                        >
                                                                                            <span className="text-zinc-400 text-base">brainstorm</span>
                                                                                            <svg className="w-5 h-5 inline-block text-purple-400 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"></path></svg>
                                                                                        </motion.button>
                                                                                        {displayProblemError ? (
                                                                                            <p className="text-red-400 text-sm mt-1 ml-3">Please describe the problem to overcome</p>
                                                                                        ) : (
                                                                                            <p className="text-zinc-400 text-sm mt-1 ml-3 opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity duration-200">The problem your customer is trying to solve (reduce costs for project x, improve customer experience for y)</p>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className=" flex-shrink-0 hidden">
                                                                        <GuidancePanel title="How to Use">
                                                                            <div className='align-center items-center text-zinc-300 '>
                                                                                {/* <ul className="space-y-2 col-span-5 text-sm text-zinc-300 ">
                                                                            <li className="flex items-start">
                                                                                    <span className="text-sky-400 mr-2">•</span>
                                                                                    <span>Company name as used in your company materials</span>
                                                                                </li>
                                                                                <li className="flex items-start">
                                                                                    <span className="text-sky-400 mr-2">•</span>
                                                                                    <span>Be specific about the problem your customer is facing</span>
                                                                                </li>
                                                                                <li className="flex items-start">
                                                                                    <span className="text-sky-400 mr-2">•</span>
                                                                                    <span>If you need ideas, click the stars <span className="text-orange-300 text-xs">* design partner testing</span></span>
                                                                                </li>
                                                                            </ul> */}
                                                                                <div className='col-span-1 w-full h-full'>
                                                                                    <motion.button
                                                                                        className="p-2.5 hover:bg-zinc-700 bg-zinc-800 rounded-md"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            const requiredFields = [
                                                                                                'promptCompanyName',
                                                                                                'promptProductName',
                                                                                                'promptCustomerRole',
                                                                                                'promptCustomerName'
                                                                                            ];
                                                                                            const emptyFields = requiredFields.filter(field => !formData[field]);

                                                                                            if (emptyFields.length > 0) {
                                                                                                setIsFormSubmitted(true);
                                                                                                // Highlight the first empty field by focusing it.
                                                                                                const firstEmptyField = document.querySelector(`[name="${emptyFields[0]}"]`);
                                                                                                if (firstEmptyField) {
                                                                                                    firstEmptyField.focus();
                                                                                                }
                                                                                                // Optionally, set a general error message or rely on individual field messages
                                                                                                setError("Please fill out all required fields before brainstorming.");
                                                                                                return;
                                                                                            }
                                                                                            setError(null); // Clear any previous errors
                                                                                            findCustomerChallenges();
                                                                                            setShowChallengesModal(true);
                                                                                        }}
                                                                                        whileHover={{ scale: 1.05 }}
                                                                                        whileTap={{ scale: 0.95 }}
                                                                                        transition={{ duration: 0.2 }}
                                                                                    >
                                                                                        <svg className="w-8 h-8 text-sky-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ transform: 'scale(1)', color: 'rgb(56, 189, 248)' }}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"></path></svg>
                                                                                    </motion.button>
                                                                                </div>
                                                                            </div>
                                                                        </GuidancePanel>
                                                                    </div>
                                                                </div>
                                                            </motion.div>
                                                        )}
                                                    </AnimatePresence>
                                                    <div className="flex justify-between mt-10">
                                                        {currentFormStep > 1 && activeScenarioTab === 0 && (
                                                            <button
                                                                type="button"
                                                                onClick={() => setCurrentFormStep(currentFormStep - 1)}
                                                                className="px-4 py-2 border border-zinc-700 text-white rounded-md hover:bg-zinc-800 transition-colors hidden"
                                                            >
                                                                Back
                                                            </button>
                                                        )}
                                                        {currentFormStep < 4 && (
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    // Validate current step fields before proceeding
                                                                    let canProceed = true;

                                                                    if (currentFormStep === 1) {
                                                                        if (!formData.promptCompanyName || !formData.promptProductName) {
                                                                            setIsFormSubmitted(true);
                                                                            canProceed = false;
                                                                        }
                                                                    } else if (currentFormStep === 2) {
                                                                        if (!formData.promptCustomerRole || !formData.promptCustomerName) {
                                                                            setIsFormSubmitted(true);
                                                                            canProceed = false;
                                                                        }
                                                                    } else if (currentFormStep === 3) {
                                                                        if (!formData.promptCustomerProblem) {
                                                                            setIsFormSubmitted(true);
                                                                            canProceed = false;
                                                                        }
                                                                    }

                                                                    if (canProceed) {
                                                                        setCurrentFormStep(currentFormStep + 1);
                                                                    }
                                                                }}
                                                                className="px-6 py-2 bg-sky-500 hover:bg-sky-400 text-white rounded-md ml-auto transition-colors"
                                                            >
                                                                Next
                                                            </button>
                                                        )}
                                                        {currentFormStep === 4 && (
                                                            <button
                                                                className={`px-4 py-2  text-white rounded-md ml-auto transition-colors ${loading ? 'animate-shimmer bg-gradient-to-r from-[#121216] via-[#1e1e25] to-[#121216] bg-[length:200%_100%]   cursor-not-allowed ' : 'hover:bg-sky-400 bg-sky-500 '}`}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setAllowGeneration(false);
                                                                    generateStory(e);
                                                                }}
                                                                disabled={loading}
                                                            >
                                                                {loading ? (
                                                                    <RotateSpinner color="#38BDF8" className="mx-auto" size={24} />
                                                                ) : (

                                                                    <>
                                                                        <span>Discover Insights</span>

                                                                        {/* <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 inline-block ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                                                                        </svg> */}
                                                                    </>
                                                                )}
                                                            </button>
                                                        )}

                                                    </div>

                                                    {/* Timer display (retained from original) */}
                                                    {!showProgressBar && (
                                                        <div className='mx-auto'>
                                                            {(timer > 0 || isTimerRunning) && (
                                                                <div className="text-zinc-100 font-mono mx-auto w-full text-center mt-4 text-lg">
                                                                    {formatTime(timer)}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </form>
                                            ) : (
                                                <></>
                                            )}
                                        </div>


                                        <div className=" w-full">
                                            <div className=" items-center ">
                                                {!showProgressBar && (
                                                    <div className='mx-auto'>
                                                        {(timer > 0 || isTimerRunning) && (
                                                            <div className="text-zinc-100 font-mono mx-auto w-full text-center mt-4 text-lg">
                                                                {formatTime(timer)}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {/* </form> */}
                                    </div>
                                </div>

                                {/* Horizontal Progress Bar */}
                                {/* {(loading || progress.completed > 0) && (
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, y: -20 }}
                                        transition={{ duration: 0.3 }}
                                        className="mb-8 mx-auto w-full w-full pl-14"
                                    >
                                        <div className="bg-black/20 rounded-lg p-6">
                                            <div className="flex justify-between items-center mb-3">
                                                <div className="text-zinc-300 text-sm font-medium">
                                                    Research & Analysis Progress
                                                </div>
                                                <div className="text-zinc-400 text-sm">
                                                    {progress.completed} of {progress.total} completed
                                                </div>
                                            </div>
                                            <div className="w-full bg-zinc-800 rounded-full h-3 overflow-hidden">
                                                <motion.div
                                                    className="h-full bg-sky-400 pulse-sky rounded-full"
                                                    initial={{ width: "0%" }}
                                                    animate={{ width: `${progress.percentage}%` }}
                                                    transition={{
                                                        duration: 0.8,
                                                        ease: "easeInOut"
                                                    }}
                                                />
                                            </div>
                                            <div className="mt-2 text-center">
                                                <motion.span
                                                    className="text-zinc-300 text-xs font-medium"
                                                    initial={{ opacity: 0 }}
                                                    animate={{ opacity: 1 }}
                                                    transition={{ delay: 0.3 }}
                                                >
                                                    {Math.round(progress.percentage)}% Complete
                                                </motion.span>
                                            </div>
                                        </div>
                                    </motion.div>
                                )} */}

                                <div ref={storyPathRef} >
                                    <CompPrintCover formData={formData} />
                                    <div className='flex print:bg-black/0 print:mx-8   print:break-after-auto ' >
                                        <div className='flex-none print:hidden'>
                                            <div className={`justify-center items-center text-sm mr-4 text-center rounded-full h-10 w-10   
                                        ${apiCalls.research || apiCalls.businessNews || apiCalls.industryTrends || apiCalls.mediaResearch || apiCalls.eli5Business || apiCalls.eli5Data || apiCalls.maxDeepData ?
                                                    "justify-center items-center text-sm text-zinc-100 font-medium mr-4  text-center  rounded-full  h-10 w-10  pt-2 text-zinc-50 border-sky-600 bg-black/20 border-2 " :
                                                    "text-zinc-400 font-medium bg-black/20 pt-2.5"
                                                }`}>
                                                2
                                            </div>
                                            <div className=' w-0.5 h-[calc(100%-40px)] mt-1  bg-white/5 ml-5'>
                                            </div>
                                        </div>

                                        <div id="know-your-customer-joyride-target" className='flex-auto  w-full   rounded-sm gap-y-0'>

                                            <div className='w-full -mt-5 p-4 text-lg text-zinc-100 font-medium '>
                                                <div className="flex justify-between items-center">
                                                    <div className={`
                                        ${apiCalls.research || apiCalls.businessNews || apiCalls.industryTrends || apiCalls.mediaResearch || apiCalls.eli5Business || apiCalls.eli5Data || apiCalls.maxDeepData ? 'text-sky-400' : 'text-zinc-400'} text-lg font-medium mt-2 print:hidden`}>Know Your Customer</div>
                                                </div>
                                            </div>

                                            {1 == 1 ? (
                                                <motion.div
                                                    initial={{ opacity: 0, y: 20 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{
                                                        duration: 0.25,
                                                        ease: "easeOut"
                                                    }}
                                                >
                                                    <div className="  print:break-before-page" ref={researchRef} id="content-id">
                                                        <Accordion
                                                            data-accordion-id={1}
                                                            open={openSections.includes(1)}

                                                            //open={open === 1} 
                                                            icon={researchData.customerInsights ? <Icon id={1} open={open} /> : null} className={`border-none  ${researchData && researchData.customerInsights ? 'rounded-t-lg' : 'bg-black/20 rounded-t-lg'} `}>
                                                            <AccordionHeader onClick={() => handleOpen(1, 1)}
                                                                className={`border-none font-normal p-3 ${apiCalls.research
                                                                    //|| apiCalls.eli5Research
                                                                    ? ' bg-gradient-to-r from-[#121216] via-[#1e1e25] to-[#121216] bg-[length:200%_100%] animate-shimmer rounded-t-lg'
                                                                    : ' hover:bg-black/10'
                                                                    }`}

                                                            >
                                                                <div className="flex justify-between items-center">

                                                                    <div className={`ml-0 text-base flex items-center ${getHeadingClass(apiCalls.research, researchData?.customerInsights || researchData?.productInsights)}`}>
                                                                        <div className="flex items-center ">
                                                                            {apiCalls.research ? (
                                                                                // <ImpulseSpinner frontColor="#38BDF8" className="inline" />
                                                                                <ThreeDotsSVGLoading />
                                                                            ) : (
                                                                                <ThreeDotsSVG />
                                                                            )}
                                                                            <div className='ml-4 mt-1 print:hidden'>Company Research</div>
                                                                            <div className='ml-10 text-3xl mt-12 text-orange-300 print:block hidden'>Company Research</div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </AccordionHeader>
                                                            <AccordionBody>
                                                                <>

                                                                    {/* <CompExplainer
                                                                        user={user}
                                                                        title="Using Company Research"
                                                                        explainerId="company-research-tips"
                                                                        type="inline"
                                                                        className="mx-10"
                                                                    >
                                                                        If you don't know how your customers make money, how can you help them make more of it? This section distills CEO-level insights so you can sound like an insider, not just another sales rep. Look for big strategic moves—expansion plans, competitive threats, shifts in focus. If you can tie your solution to their business model instead of their tech stack, you'll be playing the game at a different level.
                                                                    </CompExplainer> */}

                                                                    {(apiCalls.research || (researchData?.customerInsights || researchData?.productInsights)) && (
                                                                        <>
                                                                            <div className="  rounded text-sm text-zinc-300 h-content overflow-y-auto">
                                                                                {apiCalls.research ? (
                                                                                    <Skeleton height={128} />
                                                                                ) : researchData && (
                                                                                    <div className="  px-8   ">

                                                                                        <div className="mb-8   ">
                                                                                            {/* JobsELI5 Section */}


                                                                                            {researchData ?
                                                                                                <>
                                                                                                    <div className='flex-1 items-center px-6'>

                                                                                                        <h4 className="text-zinc-100 text-4xl sp-big-headxing mt-2 ">
                                                                                                            {/* <img src={brandLogoData.logos[0].formats[0].src} className="h-12  inline-block mr-4 mb-2 rounded-lg" /> */}
                                                                                                            {formData.promptCustomerName}</h4>
                                                                                                    </div>

                                                                                                    <div className="text-zinc-200 leading-8 py-4 text-lg w-full px-6">

                                                                                                        {researchData.customerInsights.companyOverview}</div>
                                                                                                </>
                                                                                                :
                                                                                                null
                                                                                            }




                                                                                            {businessModelData && (
                                                                                                <CompAIStoryBoardCompanyBackground businessModelData={businessModelData} />
                                                                                            )}


                                                                                            {researchDeepData && researchDeepData.storyTitle && (
                                                                                                <CompAIStoryBoardLeadership researchDeepData={researchDeepData} />
                                                                                            )}

                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </>
                                                                    )}




                                                                </>   </AccordionBody>
                                                        </Accordion></div>
                                                </motion.div>

                                            ) : (
                                                null
                                            )}

                                            {1 == 1 ? (
                                                <motion.div
                                                    initial={{ opacity: 0, y: 20 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{
                                                        duration: 0.25,
                                                        ease: "easeOut"
                                                    }}
                                                >
                                                    <div className=" " ref={businessNewsRef}>

                                                        <Accordion
                                                            open={openSections.includes(2)}
                                                            //open={open === 2} 
                                                            data-accordion-id={2}
                                                            icon={apiCallsCompleted.eli5Business ? <Icon id={2} open={open} /> : null} className={`border-none 
                                                    ${apiCallsCompleted.eli5Business ? '' : 'bg-black/20  rounded-none'} `}    >
                                                            <AccordionHeader onClick={() => handleOpen(2, 1)}

                                                                className={`border-none font-normal p-3 ${apiCalls.businessNews || apiCalls.eli5Business
                                                                    ? ' bg-gradient-to-r from-[#121216] via-[#1e1e25] to-[#121216] bg-[length:200%_100%] animate-shimmer rounded-t-lg'
                                                                    : ' hover:bg-black/10'
                                                                    }`}
                                                            >

                                                                <div className="flex justify-between items-center ">
                                                                    <h2 className={`   text-base flex items-center ${getHeadingClass(apiCalls.businessNews || apiCalls.eli5Business, businessNewsData?.newsItems)}`}>
                                                                        <div className="flex items-center">
                                                                            {apiCalls.businessNews || apiCalls.eli5Business ? (
                                                                                // <ImpulseSpinner frontColor="#38BDF8" className="inline" />
                                                                                <ThreeDotsSVGLoading />
                                                                            ) : (
                                                                                <ThreeDotsSVG />
                                                                            )}
                                                                            <div className='ml-4 mt-1 print:hidden'>Business Events</div>
                                                                            <div className='ml-10 text-3xl mt-12 text-orange-300 print:block hidden'>Business Events</div>
                                                                        </div>
                                                                    </h2>

                                                                </div>
                                                            </AccordionHeader>
                                                            <AccordionBody>
                                                                <>

                                                                    {/* <CompExplainer
                                                                        user={user}
                                                                        title="Using Business Events"
                                                                        explainerId="business-events-tips"
                                                                        type="inline"
                                                                        className="mx-10"
                                                                    >
                                                                        Timing is everything in sales and big changes = big opportunities for you to jump in with timely, relevant insights. Use the intelligence in this section to understand what's happening inside your prospect's world right now that could open a door for you. Maybe they just made an acquisition (hello, integration challenges), hired a new CTO (who wants to make a big impact fast), or launched a new product (which means pressure to hit revenue targets). Find the event that connects to what you sell, and you have a built-in reason to reach out—and more importantly, a reason for them to listen.
                                                                    </CompExplainer> */}

                                                                    {(apiCalls.businessNews || businessNewsData?.newsItems) && (
                                                                        <div className="rounded text-sm px-8 py-1 text-zinc-300 h-content overflow-y-auto  ">
                                                                            {apiCalls.businessNews ? (
                                                                                <div className="grid grid-cols-1 gap-4">
                                                                                    <Skeleton height={128} />
                                                                                </div>
                                                                            ) : businessNewsData && (
                                                                                <>
                                                                                    <div className="mb-8  ">
                                                                                        {/* JobsELI5 Section */}
                                                                                        {/* {//console.log("ELI5 Data Structure:", eli5DataBusiness)} */}

                                                                                        {/* Handle both potential structures */}
                                                                                        {(eli5DataBusiness?.simpleExplanation || eli5DataBusiness?.eli5Data?.simpleExplanation) && (
                                                                                            <div className="mb-8   grid grid-cols-8 gap-4 px-6">
                                                                                                <div className="col-span-8">
                                                                                                    <div className="text-2xl font-base leading-10 text-zinc-50 mb-2">
                                                                                                        {eli5DataBusiness?.headline || eli5DataBusiness?.eli5Data?.headline}
                                                                                                    </div>
                                                                                                    <div className="text-lg font-base leading-8 text-zinc-300 mb-4">
                                                                                                        {eli5DataBusiness?.simpleExplanation || eli5DataBusiness?.eli5Data?.simpleExplanation}
                                                                                                    </div>
                                                                                                </div>

                                                                                            </div>
                                                                                        )}
                                                                                    </div>

                                                                                                                                                        <ViewModeToggle
                                                                        data={businessNewsData}
                                                                        viewMode={newsViewMode}
                                                                        onViewModeChange={handleNewsViewModeChange}
                                                                        contentType="news"
                                                                        GridItemComponent={CompAIStoryBoardItem}
                                                                        SlideItemComponent={CompAIStoryBoardItemSlide}
                                                                        dataProperty="newsItems"
                                                                        filterProperty="headline"
                                                                        keyPrefix="grid-"
                                                                    />

                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </>   </AccordionBody>
                                                        </Accordion>
                                                    </div>
                                                </motion.div>
                                            ) : (
                                                null
                                            )}


                                            {/* Display Industry Trends Results */}
                                            <div className=" " ref={industryTrendsRef}>
                                                <Accordion

                                                    open={openSections.includes(3)}
                                                    //open={open === 3} 
                                                    icon={apiCallsCompleted.eli5Industry ? <Icon id={3} open={open} /> : null} className={`border-none 
                                            ${apiCallsCompleted.eli5Industry ? ' ' : 'bg-black/20 rounded-none'} `}>
                                                    <AccordionHeader onClick={() => handleOpen(3, 1)}

                                                        className={`border-none font-normal p-3 ${apiCalls.industryTrends && !apiCallsCompleted.eli5Industry
                                                            ? ' bg-gradient-to-r from-[#121216] via-[#1e1e25] to-[#121216] bg-[length:200%_100%] animate-shimmer rounded-t-lg'
                                                            : ' hover:bg-black/10'
                                                            }`}
                                                    >
                                                        <div className="flex justify-between items-center">
                                                            <h2 className={`  ml-0 text-base flex items-center ${getHeadingClass(apiCalls.industryTrends || !apiCallsCompleted.eli5Industry, industryTrendsData?.trendItems)}`}>
                                                                <div className="flex items-center">
                                                                    {(apiCalls.industryTrends || apiCalls.eli5Industry) && !apiCallsCompleted.eli5Industry ? (
                                                                        // <ImpulseSpinner frontColor="#38BDF8" className="inline" />
                                                                        <ThreeDotsSVGLoading />
                                                                    ) : (
                                                                        <ThreeDotsSVG />
                                                                    )}
                                                                    <div className='ml-4 mt-1 print:hidden'>Industry Insights</div>
                                                                    <div className='ml-10 text-3xl mt-12 text-orange-300 print:block hidden'>Industry Insights</div>
                                                                </div>
                                                            </h2>
                                                        </div>
                                                    </AccordionHeader>
                                                    <AccordionBody>
                                                        <>
                                                            {/* <CompExplainer
                                                                user={user}
                                                                title="Using Industry Insights"
                                                                explainerId="industry-insights-tips"
                                                                type="inline"
                                                                className="mx-10"
                                                            >
                                                                Even if your prospect's world is quiet, their industry is always moving. Regulations change, competitors launch new products, AI disrupts workflows—whatever it is, these shifts create both risks and opportunities. Your job? Help your prospect see what's coming and position yourself as the guide to help them navigate it. Bring up a relevant trend and ask, 'How's your team handling this?'—it's an easy way to start a strategic conversation instead of just a sales pitch.
                                                            </CompExplainer> */}

                                                            {(industryTrendsData && industryTrendsData?.trendItems) && (
                                                                <div className="rounded text-sm px-8 py-1 text-zinc-300 h-content overflow-y-auto">

                                                                    <div className="w-full">

                                                                        <>
                                                                            {/* {(eli5DataIndustry?.simpleExplanation ) && ( */}
                                                                            <div className="mb-8 px-6  grid grid-cols-8 gap-4">
                                                                                <div className="col-span-8">
                                                                                    <div className="text-2xl font-base leading-10 text-zinc-50 mb-6">
                                                                                        {eli5DataIndustry?.simpleExplanation || eli5DataIndustry?.eli5Data?.headline}
                                                                                    </div>
                                                                                    <div className="text-lg font-base leading-8 text-zinc-300 mb-6">
                                                                                        {eli5DataIndustry?.simpleExplanation || eli5DataIndustry?.eli5Data?.simpleExplanation}
                                                                                    </div>
                                                                                </div>

                                                                            </div>

                                                                        </>


                                                                        {/* <div className="grid grid-cols-2 gap-4">
                                                                            {industryTrendsData.trendItems
                                                                                .filter(item => item.headline)
                                                                                .map((newsItem, index) => (
                                                                                    <CompAIStoryBoardItem key={index} newsItem={newsItem} />
                                                                                ))}

                                                                        </div> */}

                                                                        <ViewModeToggle
                                                                            data={industryTrendsData}
                                                                            viewMode={industryViewMode}
                                                                            onViewModeChange={handleIndustryViewModeChange}
                                                                            contentType="industry"
                                                                            GridItemComponent={CompAIStoryBoardItem}
                                                                            SlideItemComponent={CompAIStoryBoardItemSlide}
                                                                            dataProperty="trendItems"
                                                                            filterProperty="headline"
                                                                            keyPrefix="industry-grid-"
                                                                        />

                                                                    </div>

                                                                </div>
                                                            )}
                                                        </>
                                                    </AccordionBody>
                                                </Accordion>
                                            </div>



                                            {/* New Messaging Research Section */}
                                            <div className="mt-0  mb-4">
                                                <Accordion
                                                    data-accordion-id={4}
                                                    open={openSections.includes(4)}
                                                    //open={open === 4} 
                                                    icon={apiCallsCompleted.deepLanguage ? <Icon id={4} open={open} /> : null} className={`border-none  ${apiCallsCompleted.deepLanguage && !apiCalls.deepLanguage ? 'rounded-t-lg' : 'bg-black/20 rounded-b-lg'} `}>
                                                    <AccordionHeader onClick={() => handleOpen(4, 1)}

                                                        className={`border-none font-normal p-3 ${apiCalls.deepLanguage
                                                            ? ' bg-gradient-to-r from-[#121216] via-[#1e1e25] to-[#121216] bg-[length:200%_100%] animate-shimmer rounded-t-lg'
                                                            : ' hover:bg-black/10'
                                                            }`}
                                                    >
                                                        <div className="flex justify-between items-center">

                                                            {/* <h2 className={`   text-base flex items-center ${getHeadingClass(apiCalls.businessNews || apiCalls.eli5Business, businessNewsData?.newsItems)}`}> */}

                                                            <h2 className={`  ml-0 text-base flex items-center ${getHeadingClass(
                                                                apiCalls.deepLanguage

                                                            )}`}>
                                                                <div className="flex items-center">
                                                                    {apiCalls.deepLanguage ? (
                                                                        // <ImpulseSpinner frontColor="#38BDF8" className="inline" />
                                                                        <ThreeDotsSVGLoading />
                                                                    ) : (
                                                                        <ThreeDotsSVG />
                                                                    )}
                                                                    <div className='ml-4 font-medium print:hidden'>
                                                                        Speaking their Language
                                                                        {/* <span className="text-orange-300 text-xs">(upgrade in process)</span> */}
                                                                    </div>
                                                                    <div className='ml-10 text-3xl mt-12 text-orange-300 print:block hidden'>Speaking their Language</div>
                                                                </div>
                                                            </h2>
                                                        </div>
                                                    </AccordionHeader>
                                                    <AccordionBody>
                                                        <>
                                                            {/* <CompExplainer
                                                                user={user}
                                                                title="Speaking their Language"
                                                                explainerId="media-research-tips"
                                                                type="inline"
                                                                className="mx-10"
                                                            >
                                                                Want to really stand out? Use this section. News articles give you headlines, but deep research from media—podcasts, interviews, deep-dive reports—gives you the real story. This is where execs let their guard down and talk about what actually matters to them. Look for direct pain points they admit to, or market shifts they're concerned about.  Communicate in their language.
                                                            </CompExplainer> */}







                                                            {/* {console.log("maxDeepData:", maxDeepData)} */}
                                                            {maxDeepData && (
                                                                <div className="overflow-hidden">
                                                                    <div className="px-4 sm:px-6 md:px-14">
                                                                        {/* <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                Customer Language
            </h3> */}

                                                                        {/* Narrative Story Section */}
                                                                        <div className="mb-6">
                                                                            <div className="flex justify-between">
                                                                                <div className="w-7/12">
                                                                                    <h3 className="text-4xl text-zinc-50 mb-4 sp-big-heading">Speaking their Language</h3>
                                                                                    <h4 className="text-2xl font-base leading-10 text-zinc-50 mb-6">
                                                                                        Lean into your Customer Mindset and Language
                                                                                        {/* <span className="text-orange-300 text-xs">* design partner exclusive</span> */}
                                                                                    </h4>
                                                                                </div>

                                                                                <div className="w-5/12 flex  pl-24  py-2 ">
                                                                                    <SpeakIt textToSpeak={maxDeepData.story}
                                                                                        title={maxDeepData.headline} />
                                                                                </div>
                                                                            </div>

                                                                            <div className="prose dark:prose-invert max-w-none">
                                                                                {maxDeepData.story ? (
                                                                                    <p className="text-lg font-base leading-8 text-zinc-300 mb-6">
                                                                                        {maxDeepData.story}
                                                                                    </p>
                                                                                ) : (
                                                                                    <div className="flex items-center justify-center h-20">
                                                                                        <FiveDotsSVGLoading />
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>


                                                                        <div className=" ">
                                                                            <h4 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-4">
                                                                                Questions in Your Customer's Language
                                                                            </h4>
                                                                            {maxDeepData.conversation_starters ? (
                                                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 -mx-6 mr-0">
                                                                                    {maxDeepData.conversation_starters.map((starter, index) => (
                                                                                        <CardDeepQuestions
                                                                                            key={index}
                                                                                            starter={starter}
                                                                                            index={index}
                                                                                        />
                                                                                    ))}
                                                                                </div>
                                                                            ) : (
                                                                                <div className="flex items-center justify-center h-20">
                                                                                    <FiveDotsSVGLoading />
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </>
                                                    </AccordionBody>
                                                </Accordion>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='flex mt-4' >
                                    <div className="flex-none   ">
                                        <div className={`justify-center items-center text-sm mr-4 text-center rounded-full h-10 w-10   ${apiCalls.story || apiCalls.producer || apiCalls.storyChapters || apiCalls.businessAnalysis || apiCalls.storySpeaker || apiCalls.storySpeakerSummary || apiCalls.persona || apiCalls.salesAnalysis || apiCalls.businessValue ?
                                            "justify-center items-center text-sm text-zinc-100 font-medium mr-4  text-center  rounded-full  h-10 w-10  pt-2 text-zinc-50 border-sky-600 bg-black/20 border-2 " :
                                            "text-zinc-400 font-medium bg-black/20 pt-2.5"
                                            }`}>
                                            3
                                        </div>
                                        <div className=' w-0.5 h-[calc(100%-40px)] mt-1  bg-white/5 ml-5'>
                                        </div>
                                    </div>

                                    <div
                                        //className='rounded-lg  bg-black/20 p-4 '
                                        className={` flex-auto    `}
                                    >
                                        <div className='w-full -mt-3 p-4 text-lg text-zinc-100 font-medium '>
                                            <div className={`${apiCalls.story || apiCalls.producer || apiCalls.storyChapters || apiCalls.businessAnalysis || apiCalls.storySpeaker || apiCalls.storySpeakerSummary || apiCalls.salesAnalysis || apiCalls.businessValue || apiCalls.persona ? 'text-sky-400' : 'text-zinc-400'} text-lg font-medium`}>Build Content for Collaboration</div>
                                            {/* <div className='w-full text-zinc-300 text-base'>Please complete the following setence to get our collaboration started</div> */}
                                        </div>

                                        <div id="build-content-joyride-target" ref={draftStoryRef}

                                            className={`bg-black/20 p-4  py-12 rounded-lg mb-12 ${apiCalls.story || apiCalls.producer || apiCalls.storyChapters || apiCalls.businessAnalysis || apiCalls.storySpeaker || apiCalls.storySpeakerSummary || apiCalls.persona || apiCalls.salesAnalysis || apiCalls.businessValue
                                                ? ' bg-gradient-to-r from-[#121216] via-[#1e1e25] to-[#121216] bg-[length:200%_100%] animate-shimmer rounded-lg'
                                                : '  '
                                                }`}
                                        >



                                            <div className="relative w-full">
                                                <div className="grid grid-cols-8 gap-1   rounded   rounded-md">
                                                    {[
                                                        { name: 'Stakeholders', key: 'persona' },
                                                        { name: 'Story Brainstorm', key: 'story' },
                                                        { name: 'Story Framing', key: 'producer' },
                                                        { name: 'Story Chapters', key: 'storyChapters' },
                                                        { name: 'Business Review', key: 'businessAnalysis' },
                                                        { name: 'Talk Track', key: 'storySpeaker' },
                                                        { name: 'Story Summary', key: 'storySpeakerSummary' },
                                                        { name: 'Review Analysis', key: 'salesAnalysis' },
                                                        // { name: 'Value Assessment', key: 'businessValue' },

                                                    ].map((step) => (
                                                        <div key={step.name} className="flex flex-col items-center">
                                                            <div className="text-center">
                                                                <div className={`font-base mt-1 text-base ${apiCalls[step.key] ? 'text-zinc-100' :
                                                                    sectionTimes[step.key] ? 'text-zinc-100' :
                                                                        'text-zinc-600'
                                                                    }`}>
                                                                    {step.name}
                                                                </div>
                                                                {/* {sectionTimes[step.key] && (
                                                            <span className="text-xs text-zinc-400">
                                                                {formatSectionTime(sectionTimes[step.key])}
                                                            </span>
                                                        )} */}
                                                            </div>
                                                            <div className={`relative  mt-2 w-full rounded flex items-center justify-center ${apiCalls[step.key] ? 'bg-transparent' :
                                                                sectionTimes[step.key] ? ' ' : ' '
                                                                }`}>
                                                                {apiCalls[step.key] ? (
                                                                    <FiveDotsSVGLoading />
                                                                ) : (
                                                                    <FiveDotsSVG />
                                                                )}
                                                            </div>

                                                        </div>
                                                    ))}
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <div className="text-zinc-700 text-sm mx-auto pt-8 -mb-4">Hypothesis Summary, Current to Future State, Cost of Inaction, Art of the Possible &amp; Knowledge for Conversation</div>
                                                </div>
                                            </div>

                                            <div className=" " ref={producedStoryRef}>
                                            </div>
                                        </div>
                                    </div>
                                </div>













                                <div className='flex print:bg-black/0 print:mx-8 pb-32   print:break-after-auto ' >
                                    <div className='flex-none print:hidden'>
                                        <div className={`justify-center items-center text-sm mr-4 text-center rounded-full h-10 w-10    
                                          text-zinc-400 font-medium bg-black/20 pt-2.5 mt-2"
                                      `}>
                                            4
                                        </div>

                                    </div>

                                    <div id="insights-co-creation-joyride-target" className=' w-full  rounded-sm gap-y-0'>



                                        <div className='w-full -mt-3 p-4 text-lg text-zinc-100 font-medium '>
                                            <div className={` text-zinc-400 text-lg font-medium`}>Insights &amp; Co-Creation</div>
                                        </div>

                                        {openPaths ?
                                            <>
                                                <motion.div
                                                    initial={{ opacity: 0, scale: 0.95 }}
                                                    animate={{ opacity: 1, scale: 1 }}
                                                    transition={{
                                                        duration: 0.3,
                                                        ease: "easeOut"
                                                    }}
                                                    className="bg-black/20 pb-8 rounded-lg p-6"
                                                >
                                                    <div className='w-full text-zinc-400 mb-4 text-base'>Click on a tile below for details or to co-create with our intelligence</div>

                                                    <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                                                        {discoveryTilesData
                                                            .filter(tile => {
                                                                // Only show conversation tile if user is from StoryPath.ai domain
                                                                // if (tile.id === 'conversation') {

                                                                //     const userEmail = user?.email || '';
                                                                //     return userEmail.endsWith('@storypath.ai');
                                                                // }
                                                                return true;
                                                            })
                                                            .map((tile) => {
                                                                // Log the value being passed to onClick
                                                                //console.log(`[PathProductDiscovery] Mapping tile "${tile.title}" - tabValue to pass: "${tile.tabValue}"`);
                                                                return (
                                                                    <DiscoveryTile
                                                                        key={tile.id}
                                                                        icon={tile.icon}
                                                                        title={tile.title}
                                                                        description={tile.description}
                                                                        bgColor={tile.bgColor}
                                                                        borderColor={tile.borderColor}
                                                                        textColor={tile.textColor}
                                                                        iconBgColor={tile.iconBgColor}
                                                                        onClick={() => setIsKanbanModalOpen(true)} //handleTileClick(tile.tabValue)} // Pass the handler
                                                                        //activeTabStart={tile.tabValue}
                                                                        tabValue={tile.tabValue}
                                                                        setActiveTabStart={setActiveTabStart}
                                                                        style={'tile'}
                                                                    />
                                                                );
                                                            })}
                                                    </div>

                                                    {/* <div className='w-full text-zinc-500 mt-12 mb-8 text-sm'>We have discovered the following insights and trends based on the research we have conducted</div> */}

                                                    {/* <div className='w-full mb-6 mt-12'>
        <PathProductDiscovery salesAnalysisData={salesAnalysisData} businessAnalysisData={businessAnalysisData} 
        formData={formData} storySpeakerSummaryResult={storySpeakerSummaryResult} producedResult={producedResult} businessTransformationResult={businessTransformationResult} businessCostOfInactionResult={businessCostOfInactionResult} storyVisualizationData={storyVisualizationData} storyChaptersData={storyChaptersData} storyData={storyData} onTileClick={() => setIsKanbanModalOpen(true)} />

    </div> */}

                                                </motion.div>
                                                <motion.div
                                                    initial={{ opacity: 0, scale: 0.95 }}
                                                    animate={{ opacity: 1, scale: 1 }}
                                                    transition={{
                                                        duration: 0.3,
                                                        ease: "easeOut",
                                                        delay: 0.1
                                                    }}
                                                >
                                                    <div className='w-full text-zinc-500 mt-12 mb-8 text-sm'>Insights based on the following research sources and additional data</div>

                                                    <div className="flex flex-wrap gap-4 px-2 -ml-2">



                                                        <CompSourceUrlList
                                                            caseStudiesData={caseStudiesData}
                                                            competitiveAnalysisData={competitiveAnalysisResult}
                                                            industryTrendsData={industryTrendsData}
                                                            businessNewsData={businessNewsData}
                                                            maxDeepData={maxDeepData}
                                                        />


                                                        {/* {competitiveAnalysisData && (
                                                            <div className="flex flex-wrap gap-4 px-2 -ml-2">
                                                                {competitiveAnalysisData.map((item, index) => (
                                                                    <CompAIStoryBoardItemSource key={index} newsItem={item} />
                                                                ))}
                                                            </div>
                                                        )} */}

                                                        {/* {caseStudiesData && (
                                                            <div className="flex flex-wrap gap-4 px-2 -ml-2">
                                                                {caseStudiesData.map((item, index) => (
                                                                    <CompAIStoryBoardItemSource key={index} newsItem={item.originalUrl} />
                                                                ))}
                                                            </div>
                                                        )}
                                                        
                                                        {competitiveAnalysisData   && (
                                                            <div className="flex flex-wrap gap-4 px-2 -ml-2">
                                                                {competitiveAnalysisData.data.battleCard.sources.map((sourceItem, index) => (
                                                                    <CompAIStoryBoardItemSource
                                                                        key={index}
                                                                        newsItem={sourceItem.url}
                                                                    />
                                                                ))}
                                                            </div>
                                                        )} */}
                                                    </div>
                                                </motion.div>
                                            </>
                                            :
                                            <div className=" bg-black/20 w-full rounded-lg p-8">
                                                <div className="text-zinc-600 text-base ">Waiting on Insight Discovery</div>
                                            </div>
                                        }
                                    </div>
                                </div>










                            </motion.div>
                        </>
                    )}



                {storypathType === 'library' && (
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            duration: 0.25,
                            ease: "easeOut"
                        }}
                        exit={{ y: -10, opacity: 0 }}
                    >
                        <div onSubmit={generateStory} className="  text-zinc-100 mt-8   ">

                            <StoryLibrary />

                        </div>
                    </motion.div>
                )}


                {storypathType === 'blank' && (
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ y: -10, opacity: 0 }}
                        transition={{
                            duration: 0.25,
                            ease: "easeOut"
                        }}
                    >
                        <div className="space-y-4 text-zinc-100 mt-8 p-8 bg-black/20 rounded-lg">
                            <div className="text-xl leading-6 text-gray-100 mb-8">Create Immersive Visual Story</div>

                            {/* Story Name Input */}
                            <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-600 focus-within:ring-2 focus-within:ring-inset focus-within:ring-sky-400 focus:outline-none">
                                <input
                                    type="text"
                                    // className="block w-full rounded-md border-0 p-4 bg-transparent text-gray-100 shadow-sm ring-1 ring-inset ring-zinc-700 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-sky-400 sm:text-base sm:leading-6 focus:outline-none"
                                    className={`inline-flex w-full p-3 bg-black/20 text-zinc-50 rounded border border-zinc-700 focus:border-sky-500 focus:ring-sky-500 transition-colors duration-200
[-webkit-autofill:bg-zinc-600/25] 
[-webkit-autofill:text-zinc-50] 
[-webkit-autofill:shadow-[0_0_0_30px_rgb(82_82_91_/_0.25)_inset]] 
[-webkit-autofill:hover:bg-zinc-600/25] 
[-webkit-autofill:focus:bg-zinc-600/25] 
[-webkit-autofill:active:bg-zinc-600/25]`}
                                    placeholder="Story Name"
                                    value={storyName}
                                    onChange={(e) => setStoryName(e.target.value)}
                                />
                            </div>

                            {/* Story Description Input */}
                            <div className="mt-4">
                                <textarea
                                    placeholder="Description"
                                    rows={4}
                                    className={`inline-flex w-full p-3 bg-black/20 text-zinc-50 rounded border border-zinc-700 focus:border-sky-500 focus:ring-sky-500 transition-colors duration-200
                                        [-webkit-autofill:bg-zinc-600/25] 
                                        [-webkit-autofill:text-zinc-50] 
                                        [-webkit-autofill:shadow-[0_0_0_30px_rgb(82_82_91_/_0.25)_inset]] 
                                        [-webkit-autofill:hover:bg-zinc-600/25] 
                                        [-webkit-autofill:focus:bg-zinc-600/25] 
                                        [-webkit-autofill:active:bg-zinc-600/25]`}
                                    value={storyDescription}
                                    onChange={(e) => setStoryDescription(e.target.value)}
                                />
                            </div>


                            {/* Create Button */}
                            <div className="mt-6 flex justify-end pt-12">
                                {/* <button
                                    className=" rounded-md bg-black/20 px-4 py-3 text-sm  text-zinc-50/50 shadow-sm hover:bg-black/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-500 mr-12">
                                    Create Tutorial Sample Story
                                </button> */}
                                <button
                                    onClick={createStory}
                                    className=" rounded-md bg-sky-500 px-4 py-3 text-base  text-white shadow-sm hover:bg-sky-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-500">
                                    Create Story
                                </button>
                            </div>
                        </div>
                    </motion.div>
                )}

                {storypathType === 'tutorial' && (
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            duration: 0.25,
                            ease: "easeOut"
                        }}
                        exit={{ y: -10, opacity: 0 }}
                    >
                        <div onSubmit={generateStory} className="space-y-4  text-zinc-100 mt-8  p-8 bg-black/20 rounded-lg">
                            <div>Hello</div>
                        </div>
                    </motion.div>
                )}

                {(apiCalls.research == 3333 ?
                    <div className='flex justify-between items-center w-full'>
                        <div className='w-1 
                        bg-gradient-to-b from-[#ff8a05] via-[#ff5478] to-[#ff00c6]
                animate-gradient bg-[length:100%_100%] 
                        h-12 mx-auto'></div>
                    </div>
                    :
                    <div className='flex justify-between items-center w-full'>
                        <div className='w-1 bg-black/0 h-12 mx-auto'></div>
                    </div>
                )}



            </SkeletonTheme>

            {showConfetti && (
                <ReactConfetti
                    width={window.innerWidth}
                    height={window.innerHeight}
                    gravity={0.1}
                    numberOfPieces={300}
                />
            )}

            <Joyride
                steps={joyrideSteps}
                run={runJoyride}
                continuous
                showProgress
                showSkipButton
                hideCloseButton
                scrollDuration={500}
                callback={handleJoyrideCallback}
                beaconComponent={React.forwardRef((props, ref) => (
                    <StoryJoyrideBeacon {...props} onSkip={handleSkipTour} ref={ref} />
                ))} // Wrap with React.forwardRef and pass ref
                locale={{
                    last: 'Close',
                }}
                styles={{
                    options: {
                        zIndex: 10000, // Ensure Joyride is on top of other elements
                        primaryColor: '#38bdf8', // sky-400 for buttons and active elements
                        textColor: '#333', // light gray for text
                        arrowColor: '#fff', // dark gray for tooltip arrow (same as tooltip bg)
                        backgroundColor: '#fff', // dark gray for tooltip background
                        overlayColor: 'rgba(0, 0, 0, 0.50)', // semi-transparent black for overlay
                    },
                    tooltip: {
                        border: '1px solid rgba(255, 255, 255, 0.1)', // Subtle white border similar to ring-white/10
                        borderRadius: '8px', // Rounded corners to match rounded-md
                        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05), 0 4px 6px -1px rgba(0, 0, 0, 0.1)', // Enhanced shadow
                        backdropFilter: 'blur(8px)', // Optional: adds a subtle backdrop blur effect
                    },
                    tooltipContainer: {
                        textAlign: 'left',
                    },
                    tooltipTitle: {
                        color: '#1f2937', // Darker text for better contrast
                        fontSize: '16px',
                        fontWeight: '600',
                    },
                    tooltipContent: {
                        color: '#374151', // Medium gray for content text
                        fontSize: '14px',
                        lineHeight: '1.5',
                    },
                    buttonClose: {
                        color: '#9ca3af', // medium gray for close button
                    },
                    buttonNext: {
                        backgroundColor: '#38bdf8', // sky-400
                        border: 'none',
                        borderRadius: '6px',
                        fontWeight: '500',
                    },
                    buttonBack: {
                        color: '#38bdf8', // sky-400 for back button text
                        borderRadius: '6px',
                    },
                    buttonSkip: {
                        color: '#6b7280', // gray-500 for skip button
                    }
                }}
            />

        </div>

    );
}

// Define the new wrapper component here, so it can access handleSkipTour
const StoryJoyrideBeacon = React.forwardRef(
    ({ onSkip, ...joyrideProps }, ref) => {
        return (
            <CustomBeacon // Your actual beacon component
                {...joyrideProps}        // Pass down joyride's props
                onSkip={onSkip}  // Pass the onSkip prop directly
                ref={ref}                // Forward the ref from Joyride to CustomBeacon
            />
        );
    }
);

// Define the CustomBeacon component
const CustomBeacon = React.forwardRef(function CustomBeacon({ onSkip, ...joyrideProvidedProps }, ref) {
    // onClick from joyrideProvidedProps is to activate the step (show tooltip)
    const { onClick: activateStep } = joyrideProvidedProps;

    return (
        // Ref is applied here. ANIMATION CLASSES REMOVED FOR TEST
        <div ref={ref} className="bg-zinc-50 text-zinc-900 p-8 pt-12 rounded-md shadow-lg text-center flex flex-col h-full animate__animated animate__fadeInUp">

            <div className="text-zinc-900 text-xl font-semibold   ">Welcome to the Deep Dive</div>
            <p className="text-zinc-700 text-base mb-auto pb-4 pt-4">
                Before diving in, let's take a quick tour to help you get started
            </p>


            <div className="flex gap-4 mt-4">
                <button
                    onClick={(e) => {
                        e.stopPropagation(); // Prevent activateStep if the button is clicked
                        if (onSkip) {
                            onSkip();
                        } else {
                            console.warn("onSkip function not provided");
                        }
                    }}
                    className="bg-zinc-500 hover:bg-zinc-400 text-white px-3 py-2 rounded text-sm w-full"
                >
                    Skip
                </button>

                <button
                    onClick={activateStep}
                    className="bg-sky-500 hover:bg-sky-400 text-white px-3 py-2 rounded text-sm w-full"
                >
                    Quick Tour
                </button>
            </div>
        </div>
    );
});
CustomBeacon.displayName = 'CustomBeacon'; // Good practice for dev tools

StoryJoyrideBeacon.displayName = 'StoryJoyrideBeacon';

